import React, { useEffect, useState, useCallback, useRef } from 'react';
import ReactFlow, {
  addEdge, Background, Controls, MiniMap,
  useNodesState, useEdgesState,
  Handle, Position, MarkerType,
  useReactFlow, ReactFlowProvider, Panel,
} from 'reactflow';
import 'reactflow/dist/style.css';
import api from '../api';
import InlineButtonBuilder from './InlineButtonBuilder';

const BASE_URL = "";


// ═══════════════════════════════════════════════════════════
// DİL ÖĞRENME BOT ŞABLONU
// ═══════════════════════════════════════════════════════════
const LANG_TEMPLATE = {
  name: '🌍 Dil Öğrenme Botu',
  flowType: 'game',
  endMsg: '🎓 <b>Bugünkü ders tamamlandı!</b>\n\n⭐ Bugün kazandığın XP: <b>{{xp}}</b>\n🏆 Seviye: <b>{{level}}</b>\n\nHer gün biraz daha öğren, dil öğrenmek bir maraton! Yarın seni bekliyorum! 💪',
  steps: [

    // ══════════════════════════════════════════
    // ANA MENÜ
    // ══════════════════════════════════════════
    {
      id:'s1', type:'start', position:{x:600,y:40},
      content:'🌍 <b>Dil Dünyasına Hoş Geldin, {{first_name}}!</b>\n\n🎯 Bu bot sana 5 dünya dilini eğlenceli testler, tekerleme egzersizleri ve bilgi içerikleriyle öğretecek!\n\n📊 <b>Senin İstatistiklerin:</b>\n⭐ Seviye: <b>{{level}}</b>\n⚡ Toplam XP: <b>{{xp}}</b>\n✅ Doğru Cevap: <b>{{total_correct}}</b>\n🔥 Günlük Seri: <b>{{streak}}</b> gün\n\n<i>"Bir dil bilmek bir pencere açmaktır. İki dil bilmek iki pencere. Her yeni dil yeni bir dünya görüşü kazandırır."</i> — Goethe\n\n👇 <b>Hangi dili öğrenmek istersin?</b>',
      inlineButtons:[
        [{text:'🇬🇧 İngilizce',callback:'en'},{text:'🇩🇪 Almanca',callback:'de'}],
        [{text:'🇷🇺 Rusça',callback:'ru'},{text:'🇫🇷 Fransızca',callback:'fr'}],
        [{text:'🇪🇸 İspanyolca',callback:'es'},{text:'🌍 Neden Farklı Dil?',callback:'neden'}],
        [{text:'🏆 Sıralama',callback:'sira'},{text:'📊 Benim İstatistiklerim',callback:'stats'}]
      ],
      edges:[
        {target:'en_menu',matchType:'exact',value:'en',label:'🇬🇧'},
        {target:'de_menu',matchType:'exact',value:'de',label:'🇩🇪'},
        {target:'ru_menu',matchType:'exact',value:'ru',label:'🇷🇺'},
        {target:'fr_menu',matchType:'exact',value:'fr',label:'🇫🇷'},
        {target:'es_menu',matchType:'exact',value:'es',label:'🇪🇸'},
        {target:'neden_msg',matchType:'exact',value:'neden',label:'🧠'},
        {target:'lb_node',matchType:'exact',value:'sira',label:'🏆'},
        {target:'stats_node',matchType:'exact',value:'stats',label:'📊'},
      ]
    },

    // ══════════════════════════════════════════
    // İSTATİSTİK
    // ══════════════════════════════════════════
    {
      id:'stats_node', type:'message', position:{x:1100,y:40},
      content:'📊 <b>{{first_name}} — Dil Öğrenme Raporu</b>\n\n👤 Kullanıcı: <b>{{full_name}}</b>\n⭐ Seviye: <b>{{level}}</b>\n⚡ XP: <b>{{xp}}</b>\n🔥 Günlük Seri: <b>{{streak}}</b> gün\n✅ Toplam Doğru: <b>{{total_correct}}</b>\n❌ Toplam Yanlış: <b>{{total_wrong}}</b>\n🎮 Toplam Oyun: <b>{{games_played}}</b>\n\n<b>Başarı Oranın:</b>\nHer gün buradaysan bir gün dil öğreneceksin! 💪\n\n<i>Düzenli çalışmak anlık ezber yapmaktan 10 kat etkilidir!</i>',
      inlineButtons:[[{text:'🏠 Ana Menü',callback:'ana_menu'}]],
      edges:[{target:'s1',matchType:'always',label:''}]
    },

    // ══════════════════════════════════════════
    // NEDEN FARKLI DİL
    // ══════════════════════════════════════════
    {
      id:'neden_msg', type:'message', position:{x:1300,y:40},
      content:'🧠 <b>İnsanlar Neden Farklı Dil Konuşur?</b>\n\nDünyada <b>7.139\'dan fazla dil</b> konuşulmaktadır! Bu sayı neden bu kadar büyük?\n\n🗺️ <b>1. Coğrafi İzolasyon</b>\nDağlar, nehirler, denizler toplulukları birbirinden ayırdı. İzole kalan gruplar zamanla farklı sesler ve kelimeler geliştirdi.\n\n⏳ <b>2. Zaman ve Evrim</b>\nAynı dili konuşan topluluklar ayrıldığında, her grup dili kendi yönünde geliştirdi. Latin\'den İtalyanca, Fransızca, İspanyolca, Portekizce doğdu!\n\n👑 <b>3. Siyasi Güç</b>\nİmparatorluklar kendi dillerini yaydı. Roma Latin\'i, Osmanlı Türkçeyi, İngiltere İngilizceyi dünyaya taşıdı.\n\n🔄 <b>4. Kültürel Kimlik</b>\nDil sadece iletişim değil, kimlik ve aidiyet aracıdır. Topluluklar dillerini koruyarak kimliklerini korudu.\n\n🌟 <b>Şaşırtıcı Gerçek:</b>\nDünya üzerinde en fazla dili barındıran ülke hangisidir?',
      inlineButtons:[
        [{text:'🇵🇬 Papua Yeni Gine',callback:'neden_d'},{text:'🇮🇳 Hindistan',callback:'neden_y'}],
        [{text:'🇳🇬 Nijerya',callback:'neden_y'},{text:'🇨🇳 Çin',callback:'neden_y'}]
      ],
      edges:[
        {target:'neden_dogru',matchType:'exact',value:'neden_d',label:'✅'},
        {target:'neden_yanlis',matchType:'exact',value:'neden_y',label:'❌'}
      ]
    },
    {
      id:'neden_dogru', type:'correct_answer', position:{x:1200,y:260},
      xpAmount:20, showXPGain:true,
      content:'✅ <b>Tebrikler! Doğru!</b>\n\n🇵🇬 <b>Papua Yeni Gine</b> — 800\'den fazla dil!\n\nNüfusu sadece 9 milyon olan bu ülkede bu kadar dil olmasının sebebi:\n🏔️ İnanılmaz dağlık arazi\n🌿 Yoğun ormanlar\n🏝️ Yüzlerce ada\n\nBu coğrafya toplulukları binlerce yıl boyunca birbirinden izole etti. Her vadi adeta ayrı bir dil geliştirebilir hale geldi!\n\nKarşılaştırma için: Tüm Avrupa kıtasında yaklaşık 200 dil var.\n\n+20 XP kazandın! 🌟',
      edges:[{target:'neden_devam',matchType:'always',label:''}]
    },
    {
      id:'neden_yanlis', type:'wrong_answer', position:{x:1400,y:260},
      content:'❌ <b>Yanlış!</b>\n\nDoğru cevap: <b>Papua Yeni Gine 🇵🇬</b>\n\n800\'den fazla dil! Nüfusu 9 milyon olan küçük bir ülke.\n\nHindistan\'da 122 resmi dil, Nijerya\'da 520+ dil var ama Papua Yeni Gine\'nin rekorunu kimse kıramıyor.\n\nNedeni: Aşılması çok zor dağlar ve ormanlar her küçük topluluğu izole etti.',
      edges:[{target:'neden_devam',matchType:'always',label:''}]
    },
    {
      id:'neden_devam', type:'message', position:{x:1300,y:420},
      content:'🌍 <b>Dil Öğrenmenin Faydaları Neler?</b>\n\nBilim insanları dil öğrenmenin beyne etkilerini inceledi ve şaşırtıcı sonuçlar buldu:\n\n🧠 <b>Beyin Sağlığı</b>\nİki dil bilen kişilerde Alzheimer hastalığı ortalama <b>4-5 yıl daha geç</b> başlıyor!\n\n💼 <b>Kariyer Avantajı</b>\nİkinci bir dil bilen çalışanlar ortalama <b>%5-20 daha yüksek maaş</b> alıyor.\n\n✈️ <b>Seyahat Özgürlüğü</b>\nSadece İngilizce öğrenerek dünyanın %60\'ıyla iletişim kurabilirsin.\n\n🤝 <b>Sosyal Bağlantı</b>\nBirinin dilinde konuşmak onun kalbini kazanmanın en kısa yolu.\n\n🎯 <b>Kritik Düşünce</b>\nİki dilde düşünmek beynin farklı bölgelerini aktive eder, problem çözme yeteneğini güçlendirir.\n\n💡 <b>Hangi dil sana en çok faydalı olur?</b>',
      inlineButtons:[
        [{text:'💼 Kariyer için: İngilizce',callback:'en'},{text:'🏛️ Kültür için: Almanca',callback:'de'}],
        [{text:'🌍 Coğrafya için: Rusça',callback:'ru'},{text:'💕 Romantizm için: Fransızca',callback:'fr'}],
        [{text:'🌮 Büyüme için: İspanyolca',callback:'es'},{text:'🏠 Ana Menü',callback:'ana_menu'}]
      ],
      edges:[
        {target:'en_menu',matchType:'exact',value:'en',label:''},
        {target:'de_menu',matchType:'exact',value:'de',label:''},
        {target:'ru_menu',matchType:'exact',value:'ru',label:''},
        {target:'fr_menu',matchType:'exact',value:'fr',label:''},
        {target:'es_menu',matchType:'exact',value:'es',label:''},
        {target:'s1',matchType:'always',label:''}
      ]
    },

    // ══════════════════════════════════════════
    // İNGİLİZCE MENÜ
    // ══════════════════════════════════════════
    {
      id:'en_menu', type:'message', position:{x:100,y:260},
      content:'🇬🇧 <b>İngilizce — Dünya\'nın Ortak Dili</b>\n\n📊 <b>Hızlı İstatistikler:</b>\n• Ana dil konuşucusu: 370 milyon\n• Toplam konuşucu: 1,5+ milyar\n• Resmi dil olduğu ülke: 67\n• İnternetteki içeriğin %55\'i İngilizce\n• En çok Nobel ödülü alan dil\n\n🌐 <b>Neden İngilizce?</b>\nİş dünyasında, bilimde, teknolojide ve uluslararası ilişkilerde İngilizce fiilen dünya ortak dili konumunda. Bir İngilizce cümle kurabilen biri teorik olarak dünyanın her köşesinde anlaşabilir.\n\n✈️ <b>İngilizce bilen biri için açık kapılar:</b>\nABD, İngiltere, Kanada, Avustralya, Yeni Zelanda iş vizesi kolaylığı. Dünya\'nın her üniversitesinde yüksek lisans imkânı.\n\n👇 <b>Ne yapmak istersin?</b>',
      inlineButtons:[
        [{text:'🧪 Beceri Testi (5 Soru)',callback:'en_test'},{text:'📚 Kelime Dünyası',callback:'en_kelime'}],
        [{text:'👅 Tekerleme Egzersizi',callback:'en_tekerleme'},{text:'📖 Gramer Rehberi',callback:'en_gramer'}],
        [{text:'⚡ Hızlı Okuma Testi',callback:'en_okuma'},{text:'🏠 Ana Menü',callback:'ana_menu'}]
      ],
      edges:[
        {target:'en_t1',matchType:'exact',value:'en_test',label:'Test'},
        {target:'en_kelime_msg',matchType:'exact',value:'en_kelime',label:'Kelime'},
        {target:'en_tek_msg',matchType:'exact',value:'en_tekerleme',label:'Tek'},
        {target:'en_gramer_msg',matchType:'exact',value:'en_gramer',label:'Gramer'},
        {target:'en_okuma_msg',matchType:'exact',value:'en_okuma',label:'Okuma'},
        {target:'s1',matchType:'exact',value:'ana_menu',label:'🏠'}
      ]
    },

    // ── İNGİLİZCE TEST (5 SORU) ──
    {
      id:'en_t1', type:'message', position:{x:0,y:480},
      content:'🧪 <b>İngilizce Beceri Testi Başlıyor!</b>\n\n5 soru, her doğru cevap XP kazandırır.\nYanlış cevaplarda da doğrusu anlatılır — yani kaybedecek bir şeyin yok!\n\n<b>Zorluk:</b> Orta-İleri\n<b>Konu:</b> Kelime bilgisi + Gramer + Kültür\n\nHazır mısın? 🎯',
      inlineButtons:[[{text:'✅ Hazırım, Başlat!',callback:'baslat_en'}]],
      edges:[{target:'en_q1',matchType:'always',label:''}]
    },
    {
      id:'en_q1', type:'message', position:{x:0,y:640},
      content:'🇬🇧 <b>Soru 1/5 — Kelime</b>\n\n"<b>Ephemeral</b>" kelimesinin anlamı nedir?\n\n💡 İpucu: Bu kelime genellikle şiirde ve felsefi metinlerde geçer.',
      inlineButtons:[
        [{text:'A) Kısa ömürlü, geçici',callback:'en_q1_d'}],
        [{text:'B) Sonsuz, kalıcı',callback:'en_q1_y'}],
        [{text:'C) Güçlü, dayanıklı',callback:'en_q1_y'}],
        [{text:'D) Karanlık, kasvetli',callback:'en_q1_y'}]
      ],
      edges:[
        {target:'en_q1_dogru',matchType:'exact',value:'en_q1_d',label:'✅'},
        {target:'en_q1_yanlis',matchType:'exact',value:'en_q1_y',label:'❌'}
      ]
    },
    {
      id:'en_q1_dogru', type:'correct_answer', position:{x:-100,y:820},
      xpAmount:15, showXPGain:true,
      content:'✅ <b>Mükemmel! Doğru!</b>\n\n<b>Ephemeral</b> = Kısa ömürlü, geçici, anlık\n\n📖 Örnek kullanımlar:\n• <i>"Social media fame is ephemeral"</i> — Sosyal medya şöhreti geçicidir\n• <i>"The ephemeral beauty of cherry blossoms"</i> — Kiraz çiçeklerinin geçici güzelliği\n\n🌸 Japonların "mono no aware" (şeylerin geçiciliğine duyulan hassasiyet) felsefesi de tam bu kelimeyi anlatır!\n\n+15 XP 🌟',
      edges:[{target:'en_q2',matchType:'always',label:''}]
    },
    {
      id:'en_q1_yanlis', type:'wrong_answer', position:{x:100,y:820},
      content:'❌ <b>Yanlış!</b>\n\n<b>Ephemeral</b> = Kısa ömürlü, geçici\n\n📖 Yunanca "ephemeros" kelimesinden gelir.\n"Epi" (üzerinde) + "hemera" (gün) = "Bir günlük"\n\nBu kelimeyi bir kez duyduğunda unutmazsın:\n<i>"Ephemeral"</i> — Tıpkı güzel bir anın geçip gitmesi gibi...',
      edges:[{target:'en_q2',matchType:'always',label:''}]
    },
    {
      id:'en_q2', type:'message', position:{x:0,y:1000},
      content:'🇬🇧 <b>Soru 2/5 — Gramer</b>\n\nHangisi dilbilgisel olarak doğrudur?',
      inlineButtons:[
        [{text:'A) I have went to London',callback:'en_q2_y'}],
        [{text:'B) I have been to London',callback:'en_q2_d'}],
        [{text:'C) I has gone to London',callback:'en_q2_y'}],
        [{text:'D) I had went to London',callback:'en_q2_y'}]
      ],
      edges:[
        {target:'en_q2_dogru',matchType:'exact',value:'en_q2_d',label:'✅'},
        {target:'en_q2_yanlis',matchType:'exact',value:'en_q2_y',label:'❌'}
      ]
    },
    {
      id:'en_q2_dogru', type:'correct_answer', position:{x:-100,y:1180},
      xpAmount:15, showXPGain:true,
      content:'✅ <b>Harika!</b>\n\n"<b>I have been to London</b>" — Present Perfect doğru kullanım!\n\n📚 <b>Present Perfect Kuralı:</b>\n• Have/Has + Past Participle\n• "Go" fiilinin past participle\'ı: <b>gone</b> veya <b>been</b>\n• "Been" kullanılır → o yere gitmiş ve geri dönmüş\n• "Gone" kullanılır → henüz oradadır\n\n<i>"I have been to Paris"</i> = Paris\'e gittim (döndüm)\n<i>"She has gone to Paris"</i> = Paris\'e gitti (hâlâ orada)\n\n+15 XP 🌟',
      edges:[{target:'en_q3',matchType:'always',label:''}]
    },
    {
      id:'en_q2_yanlis', type:'wrong_answer', position:{x:100,y:1180},
      content:'❌ Doğru: <b>I have been to London</b>\n\n📚 Present Perfect: have/has + past participle\n• Go → went (past) → gone/been (past participle)\n• "Went" hiçbir zaman have ile kullanılmaz!\n\n<i>I went to London</i> ✓ (Simple Past)\n<i>I have been to London</i> ✓ (Present Perfect)',
      edges:[{target:'en_q3',matchType:'always',label:''}]
    },
    {
      id:'en_q3', type:'message', position:{x:0,y:1360},
      content:'🇬🇧 <b>Soru 3/5 — Atasözü</b>\n\n"<b>The pen is mightier than the sword</b>" atasözünün anlamı nedir?',
      inlineButtons:[
        [{text:'A) Yazı ve fikirler güçten üstündür',callback:'en_q3_d'}],
        [{text:'B) Kılıç kalemden daha güçlüdür',callback:'en_q3_y'}],
        [{text:'C) Savaş her zaman kazanır',callback:'en_q3_y'}],
        [{text:'D) Barış mümkün değildir',callback:'en_q3_y'}]
      ],
      edges:[
        {target:'en_q3_dogru',matchType:'exact',value:'en_q3_d',label:'✅'},
        {target:'en_q3_yanlis',matchType:'exact',value:'en_q3_y',label:'❌'}
      ]
    },
    {
      id:'en_q3_dogru', type:'correct_answer', position:{x:-100,y:1540},
      xpAmount:15, showXPGain:true,
      content:'✅ <b>Bravo!</b>\n\n"Yazı ve fikirler güçten üstündür"\n\n📜 <b>Tarihçesi:</b>\nEdward Bulwer-Lytton\'ın 1839 tarihli tiyatro eserinden alınan bu söz bugün İngilizce\'nin en bilinen atasözlerinden biri haline geldi.\n\n💡 <b>Benzer Türkçe Söz:</b>\n"Söz gümüşse, sükut altındır" — Ama bu biraz farklı anlam taşır 😄\n\nBu atasözünün en güzel yanı: Tarihteki en büyük değişimlerin silahtan değil fikirden geldiğini kanıtlamış olması!\n\n+15 XP 🌟',
      edges:[{target:'en_q4',matchType:'always',label:''}]
    },
    {
      id:'en_q3_yanlis', type:'wrong_answer', position:{x:100,y:1540},
      content:'❌ Doğru: <b>Yazı ve fikirler güçten üstündür</b>\n\n"The pen is mightier than the sword"\nKalem (fikir/yazı) kılıçtan (güç/şiddet) daha güçlüdür.\n\nEdward Bulwer-Lytton, 1839 — Bu söz tarihin en etkili sözlerinden biri oldu.',
      edges:[{target:'en_q4',matchType:'always',label:''}]
    },
    {
      id:'en_q4', type:'message', position:{x:0,y:1720},
      content:'🇬🇧 <b>Soru 4/5 — Yazım</b>\n\nHangisi İngilizce\'de DOĞRU yazılmıştır?',
      inlineButtons:[
        [{text:'A) Accomodation',callback:'en_q4_y'}],
        [{text:'B) Acommodation',callback:'en_q4_y'}],
        [{text:'C) Accommodation',callback:'en_q4_d'}],
        [{text:'D) Accomodattion',callback:'en_q4_y'}]
      ],
      edges:[
        {target:'en_q4_dogru',matchType:'exact',value:'en_q4_d',label:'✅'},
        {target:'en_q4_yanlis',matchType:'exact',value:'en_q4_y',label:'❌'}
      ]
    },
    {
      id:'en_q4_dogru', type:'correct_answer', position:{x:-100,y:1900},
      xpAmount:15, showXPGain:true,
      content:'✅ <b>Süper!</b>\n\n<b>Accommodation</b> — Doğru!\n\n💡 <b>Hatırlama Yöntemi:</b>\nACC + OMM + ODATION\nİki "c", iki "m"\n\n🔤 <b>Diğer sık yanlış yazılan kelimeler:</b>\n• Receive (Recieve değil!)\n• Separate (Seperate değil!)\n• Necessary (Neccessary değil!)\n• Definitely (Definately değil!)\n• Occurrence (Occurence değil!)\n\nBu listeyi ezi ezberle, yazım hatası yapamazsın! 📝\n+15 XP 🌟',
      edges:[{target:'en_q5',matchType:'always',label:''}]
    },
    {
      id:'en_q4_yanlis', type:'wrong_answer', position:{x:100,y:1900},
      content:'❌ Doğru: <b>Accommodation</b>\n\nACC + OMM + ODATION = İki c, iki m!\n\n💡 İngilizce\'nin en çok yazım hatası yapılan kelimeleri:\nReceive, Separate, Necessary, Accommodation\n\nHepsini bir kez doğru yaz, hafızana işlesin!',
      edges:[{target:'en_q5',matchType:'always',label:''}]
    },
    {
      id:'en_q5', type:'message', position:{x:0,y:2080},
      content:'🇬🇧 <b>Son Soru 5/5 — Kültür & Dil</b>\n\nİngilizce\'nin en uzun kelimesi (teknik olmayan günlük kullanımda) hangisidir?',
      inlineButtons:[
        [{text:'A) Incomprehensible',callback:'en_q5_y'}],
        [{text:'B) Uncharacteristically',callback:'en_q5_y'}],
        [{text:'C) Pneumonoultramicroscopicsilicovolcanoconiosis',callback:'en_q5_d'}],
        [{text:'D) Supercalifragilisticexpialidocious',callback:'en_q5_y'}]
      ],
      edges:[
        {target:'en_q5_dogru',matchType:'exact',value:'en_q5_d',label:'✅'},
        {target:'en_q5_yanlis',matchType:'exact',value:'en_q5_y',label:'❌'}
      ]
    },
    {
      id:'en_q5_dogru', type:'correct_answer', position:{x:-100,y:2260},
      xpAmount:20, showXPGain:true,
      content:'✅ <b>İnanılmaz! Doğru!</b>\n\n<b>Pneumonoultramicroscopicsilicovolcanoconiosis</b>\n45 harf! 🎉\n\nBu kelime bir akciğer hastalığını tanımlar: Yanardağ külleri solumaktan oluşan silikozis.\n\n😄 Mary Poppins filmindeki "Supercalifragilisticexpialidocious" da 34 harfle 2. sırada!\n\n+20 XP Bonus! 🌟',
      edges:[{target:'en_test_son',matchType:'always',label:''}]
    },
    {
      id:'en_q5_yanlis', type:'wrong_answer', position:{x:100,y:2260},
      content:'❌ Doğru: <b>Pneumonoultramicroscopicsilicovolcanoconiosis</b>\n\n45 harf ile sözlükteki en uzun kelime!\nBir akciğer hastalığının adı.\n\nOkumayı dene: Pnömo-ultra-mikroskopik-siliko-volkan-koniyozis 😅',
      edges:[{target:'en_test_son',matchType:'always',label:''}]
    },
    {
      id:'en_test_son', type:'message', position:{x:0,y:2440},
      content:'🎉 <b>İngilizce Testi Tamamlandı!</b>\n\n📊 <b>Sonuçların:</b>\n⭐ Seviye: <b>{{level}}</b>\n⚡ Toplam XP: <b>{{xp}}</b>\n✅ Toplam Doğru: <b>{{total_correct}}</b>\n\n<b>Performans Değerlendirmesi:</b>\n🏆 5/5 Doğru → Dil dahisi!\n⭐ 3-4/5 Doğru → Çok iyi!\n👍 1-2/5 Doğru → Başlangıç iyi!\n\n<i>Unutma: Her hata bir öğrenme fırsatıdır!</i>\n\n💪 Devam etmek ister misin?',
      inlineButtons:[
        [{text:'🔁 Testi Tekrar Al',callback:'en_test'},{text:'📚 Kelime Öğren',callback:'en_kelime'}],
        [{text:'👅 Tekerleme Dene',callback:'en_tekerleme'},{text:'🏠 Ana Menü',callback:'ana_menu'}]
      ],
      edges:[
        {target:'en_t1',matchType:'exact',value:'en_test',label:'Tekrar'},
        {target:'en_kelime_msg',matchType:'exact',value:'en_kelime',label:'Kelime'},
        {target:'en_tek_msg',matchType:'exact',value:'en_tekerleme',label:'Tek'},
        {target:'s1',matchType:'always',label:'Menü'}
      ]
    },

    // ── İNGİLİZCE KELİME ──
    {
      id:'en_kelime_msg', type:'message', position:{x:300,y:480},
      content:'📚 <b>İngilizce\'nin En Güzel ve Çevirisi Zor Kelimeleri</b>\n\nBazı kelimeler o kadar derin anlam taşır ki başka dillere çevirmek neredeyse imkânsız:\n\n✨ <b>Serendipity</b> — Tesadüf eseri güzel bir şey keşfetme yeteneği\n<i>"I found my best friend by serendipity"</i>\n\n✨ <b>Wanderlust</b> — (Almanca kökenli) Gezme ve keşfetme tutkusu\n<i>"Wanderlust hit me every spring"</i>\n\n✨ <b>Petrichor</b> — Yağmur sonrası toprağın kokusu\n<i>"I love the petrichor after summer rain"</i>\n\n✨ <b>Hiraeth</b> — (Galce kökenli) Var olmayan ya da kaybedilen bir yere özlem\n\n✨ <b>Sonder</b> — Her yabancının da kendi karmaşık hayatı olduğunu fark etme anı\n\n✨ <b>Limerence</b> — Karşılıklılık umuduyla birlikte olan aşırı romantik bağlanma hali\n\n✨ <b>Vellichor</b> — Eski kitapçıların garip melankolik havası\n\n<i>Bu kelimelerden birini bugün kullana bilir misin? 😊</i>',
      inlineButtons:[
        [{text:'🧪 Testi Dene',callback:'en_test'},{text:'📖 Gramer Öğren',callback:'en_gramer'}],
        [{text:'🏠 Ana Menü',callback:'ana_menu'}]
      ],
      edges:[
        {target:'en_t1',matchType:'exact',value:'en_test',label:'Test'},
        {target:'en_gramer_msg',matchType:'exact',value:'en_gramer',label:'Gramer'},
        {target:'s1',matchType:'always',label:'Menü'}
      ]
    },

    // ── İNGİLİZCE TEKERLEME ──
    {
      id:'en_tek_msg', type:'message', position:{x:600,y:480},
      content:'👅 <b>İngilizce Tekerleme Egzersizi</b>\n\nTekerleme (tongue twister) telaffuzunu geliştirmenin en eğlenceli yolu!\n\n🔊 <b>1. Klasik:</b>\n<code>She sells seashells by the seashore.\nThe shells she sells are surely seashells.\nSo if she sells shells on the seashore,\nI\'m sure she sells seashore shells.</code>\n\n🔊 <b>2. Peter Piper:</b>\n<code>Peter Piper picked a peck of pickled peppers.\nA peck of pickled peppers Peter Piper picked.\nIf Peter Piper picked a peck of pickled peppers,\nWhere\'s the peck of pickled peppers Peter Piper picked?</code>\n\n🔊 <b>3. Dünyanın En Zor Tekerleme:</b>\n<code>The sixth sick sheikh\'s sixth sheep\'s sick.</code>\n\n💡 <b>Pratik Yöntemi:</b>\n1. Önce yavaş oku\n2. Sonra biraz hızlan\n3. En hızlı haliyle 3 kez tekrar et\n\n⏱️ Kaç kez başarıyla söyledin?',
      inlineButtons:[
        [{text:'😅 1-2 kez — Zor!',callback:'tek_xp5'},{text:'💪 3-5 kez — İyi!',callback:'tek_xp10'}],
        [{text:'🔥 5+ kez — Harika!',callback:'tek_xp20'},{text:'🏠 Ana Menü',callback:'ana_menu'}]
      ],
      edges:[
        {target:'en_tek_xp5',matchType:'exact',value:'tek_xp5',label:''},
        {target:'en_tek_xp10',matchType:'exact',value:'tek_xp10',label:''},
        {target:'en_tek_xp20',matchType:'exact',value:'tek_xp20',label:''},
        {target:'s1',matchType:'always',label:''}
      ]
    },
    {id:'en_tek_xp5', type:'add_xp', position:{x:500,y:680}, xpAmount:5, showXPGain:true,
     content:'5 XP kazandın! Pratik yaparsan gelişirsin! 💪',
     edges:[{target:'en_menu',matchType:'always',label:''}]},
    {id:'en_tek_xp10', type:'add_xp', position:{x:620,y:680}, xpAmount:10, showXPGain:true,
     content:'10 XP! Çok iyi gidiyorsun! 🌟',
     edges:[{target:'en_menu',matchType:'always',label:''}]},
    {id:'en_tek_xp20', type:'add_xp', position:{x:740,y:680}, xpAmount:20, showXPGain:true,
     levelUpMessage:'🎉 Tekerleme ustası! Seviye atladın! 🏆',
     content:'20 XP! Tekerleme ustasısın! 🔥',
     edges:[{target:'en_menu',matchType:'always',label:''}]},

    // ── İNGİLİZCE GRAMER ──
    {
      id:'en_gramer_msg', type:'message', position:{x:900,y:480},
      content:'📖 <b>İngilizce Gramer — En Sık Yapılan 10 Hata</b>\n\nTüm seviyelerdeki öğrencilerin tekrarlayan hataları:\n\n❌→✅ <b>1. Their / There / They\'re</b>\n• Their = Onların (sahiplik)\n• There = Orada (yer)\n• They\'re = They are (kısaltma)\n\n❌→✅ <b>2. Its / It\'s</b>\n• Its = Onun (sahiplik — the dog licked its paw)\n• It\'s = It is (kısaltma)\n\n❌→✅ <b>3. Your / You\'re</b>\n• Your = Senin\n• You\'re = You are\n\n❌→✅ <b>4. Less / Fewer</b>\n• Less = sayılamayan şeyler için (less water, less time)\n• Fewer = sayılabilir şeyler için (fewer students, fewer cars)\n\n❌→✅ <b>5. Who / Whom</b>\n• Who = Özne konumundaki kişi\n• Whom = Nesne konumundaki kişi\n<i>"Who did it?" vs "To whom did you give it?"</i>\n\n❌→✅ <b>6. Lie / Lay</b>\n• Lie = (kendi başına) yatmak\n• Lay = (bir şeyi) yatırmak, bırakmak\n\n❌→✅ <b>7. Affect / Effect</b>\n• Affect = Etkilemek (fiil)\n• Effect = Etki (isim)\n\n💡 Bu farkları ezberlemek 1-2 günde olur, ama görmezden gelmek yıllarca sürer!',
      inlineButtons:[
        [{text:'🧪 Test Çöz',callback:'en_test'},{text:'🏠 Ana Menü',callback:'ana_menu'}]
      ],
      edges:[
        {target:'en_t1',matchType:'exact',value:'en_test',label:'Test'},
        {target:'s1',matchType:'always',label:'Menü'}
      ]
    },

    // ── İNGİLİZCE OKUMA ──
    {
      id:'en_okuma_msg', type:'message', position:{x:1100,y:480},
      content:'⚡ <b>Hızlı Okuma ve Anlama Testi</b>\n\nAşağıdaki metni dikkatlice oku:\n\n<i>"Language shapes the way we think, and determines what we can think about. The limits of my language mean the limits of my world, as Wittgenstein famously stated. When we learn a new language, we do not merely add a communication tool to our repertoire — we expand the very boundaries of our consciousness. Each language carries within it a unique way of perceiving time, space, relationships, and reality itself. Japanese speakers, for example, have words for concepts that English simply cannot capture in a single term: \'Komorebi\' — the interplay between light and leaves when sunlight shines through trees, \'Wabi-sabi\' — the beauty of imperfection and impermanence."</i>\n\n❓ <b>Bu metne göre, yeni bir dil öğrenmek ne anlama gelir?</b>',
      inlineButtons:[
        [{text:'A) Sadece yeni kelimeler öğrenmek',callback:'en_oku_y'}],
        [{text:'B) Bilincimizin sınırlarını genişletmek',callback:'en_oku_d'}],
        [{text:'C) Daha hızlı konuşabilmek',callback:'en_oku_y'}],
        [{text:'D) Kültürel farklılıkları azaltmak',callback:'en_oku_y'}]
      ],
      edges:[
        {target:'en_oku_dogru',matchType:'exact',value:'en_oku_d',label:'✅'},
        {target:'en_oku_yanlis',matchType:'exact',value:'en_oku_y',label:'❌'}
      ]
    },
    {
      id:'en_oku_dogru', type:'correct_answer', position:{x:1000,y:680},
      xpAmount:25, showXPGain:true,
      content:'✅ <b>Harika! Derinlemesine anlıyorsun!</b>\n\nMetin tam olarak şunu söylüyor:\nDil öğrenmek = Bilincimizin sınırlarını genişletmek\n\n🧠 Wittgenstein\'ın "Dilimin sınırları dünyamın sınırlarıdır" sözü çok derin!\n\n💡 "Komorebi" ve "Wabi-sabi" gibi kelimelere sahip olan Japonların, bu kavramları İngilizce konuşanlardan farklı algıladığı bilimsel olarak kanıtlanmış!\n\n+25 XP — Okuma anlama başarısı! 🎖️',
      edges:[{target:'en_menu',matchType:'always',label:''}]
    },
    {
      id:'en_oku_yanlis', type:'wrong_answer', position:{x:1150,y:680},
      content:'❌ Doğru: <b>Bilincimizin sınırlarını genişletmek</b>\n\nMetin diyor ki: Yeni bir dil öğrendiğimizde sadece iletişim aracı eklemiyoruz, bilincimizin gerçek sınırlarını genişletiyoruz.\n\nHer dil zaman, mekân ve gerçekliği algılama biçimi getirir!',
      edges:[{target:'en_menu',matchType:'always',label:''}]
    },

    // ══════════════════════════════════════════
    // ALMANCA MENÜ
    // ══════════════════════════════════════════
    {
      id:'de_menu', type:'message', position:{x:1400,y:260},
      content:'🇩🇪 <b>Almanca — Avrupa\'nın Güçlü Dili</b>\n\n📊 <b>Almanca Hakkında:</b>\n• Ana dil: 100 milyon konuşucu\n• AB\'nin en çok konuşulan ana dili\n• Resmi dil: Almanya, Avusturya, İsviçre, Lüksemburg, Liechtenstein\n• Nobel ödüllü bilim insanlarının büyük çoğunluğunun ana dili\n• Dünya\'nın en çok çevirisi yapılan 2. dili\n\n🏭 <b>Almanca Neden Öğrenilmeli?</b>\nAlmanya, Avrupa\'nın en büyük ekonomisi. Alman şirketleri (BMW, Mercedes, Siemens, Bosch, SAP) dünyada binlerce pozisyon için Almanca bilen çalışan arıyor. Almanca bilen bir mühendis veya teknik uzman Almanya\'da çok cazip maaş paketleri alabiliyor.\n\n🎭 <b>Kültürel Zenginlik:</b>\nGoethe, Schiller, Kafka, Nietzsche, Hegel, Kant — Dünya edebiyatının ve felsefesinin devleri Almanca yazdı!\n\n👇 <b>Ne yapmak istersin?</b>',
      inlineButtons:[
        [{text:'🧪 Test Çöz (5 Soru)',callback:'de_test'},{text:'📖 Almanca Sözler',callback:'de_sozler'}],
        [{text:'👅 Tekerleme',callback:'de_tek'},{text:'🧩 İlginç Almanca Kelimeler',callback:'de_kelime'}],
        [{text:'🏠 Ana Menü',callback:'ana_menu'}]
      ],
      edges:[
        {target:'de_t1',matchType:'exact',value:'de_test',label:'Test'},
        {target:'de_sozler_msg',matchType:'exact',value:'de_sozler',label:'Sözler'},
        {target:'de_tek_msg',matchType:'exact',value:'de_tek',label:'Tek'},
        {target:'de_kelime_msg',matchType:'exact',value:'de_kelime',label:'Kelime'},
        {target:'s1',matchType:'exact',value:'ana_menu',label:'🏠'}
      ]
    },
    {
      id:'de_t1', type:'message', position:{x:1300,y:480},
      content:'🇩🇪 <b>Almanca Testi — 5 Soru</b>\n\nAlmanca\'nın en büyük özelliği: Kelimeler birleştirilerek yeni anlamlar oluşturulur! Bu teste de bunu dahil ettik.\n\nHer doğru +15 XP. Hazır mısın?',
      inlineButtons:[[{text:'✅ Başlat!',callback:'baslat_de'}]],
      edges:[{target:'de_q1',matchType:'always',label:''}]
    },
    {
      id:'de_q1', type:'message', position:{x:1300,y:640},
      content:'🇩🇪 <b>Soru 1/5 — Anlamı En Güzel Kelime</b>\n\n"<b>Fernweh</b>" kelimesi ne anlama gelir?\n\n💡 İpucu: "Fern" = uzak, "Weh" = acı, özlem',
      inlineButtons:[
        [{text:'A) Uzak yerlere duyulan özlem ve seyahat arzusu',callback:'de_q1_d'}],
        [{text:'B) Geçmişe duyulan güçlü nostalji',callback:'de_q1_y'}],
        [{text:'C) Yükseklik korkusu',callback:'de_q1_y'}],
        [{text:'D) Başarısızlık korkusu',callback:'de_q1_y'}]
      ],
      edges:[
        {target:'de_q1_d',matchType:'exact',value:'de_q1_d',label:'✅'},
        {target:'de_q1_y',matchType:'exact',value:'de_q1_y',label:'❌'}
      ]
    },
    {
      id:'de_q1_d', type:'correct_answer', position:{x:1200,y:820},
      xpAmount:15, showXPGain:true,
      content:'✅ <b>Wunderbar!</b>\n\n<b>Fernweh</b> = Uzak yerlere duyulan özlem\n\nBu kelimenin karşıtı: <b>Heimweh</b> (memleket özlemi)\n\nFernweh\'e yakın kelimeler diğer dillerde:\n🇵🇹 Portugizce: Saudade (genel özlem hissi)\n🇩🇰 Danimarkaca: Hygge (bu farklı ama güzel bir kavram)\n\nAlmancada bu tip birleşik kavram kelimeleri çok! +15 XP 🌟',
      edges:[{target:'de_q2',matchType:'always',label:''}]
    },
    {
      id:'de_q1_y', type:'wrong_answer', position:{x:1400,y:820},
      content:'❌ Doğru: <b>Uzak yerlere duyulan özlem</b>\n\nFernweh = Fern (uzak) + Weh (acı/özlem)\n\nKarşıtı: Heimweh = Heim (ev) + Weh = Memleket özlemi\nAlmanca bu birleşik kelimelerle çok zengin!',
      edges:[{target:'de_q2',matchType:'always',label:''}]
    },
    {
      id:'de_q2', type:'message', position:{x:1300,y:1000},
      content:'🇩🇪 <b>Soru 2/5 — Temel Almanca</b>\n\nAşağıdaki selamlaşmalardan hangisi <b>akşam</b> için kullanılır?',
      inlineButtons:[
        [{text:'A) Guten Morgen',callback:'de_q2_y'}],
        [{text:'B) Guten Tag',callback:'de_q2_y'}],
        [{text:'C) Guten Abend',callback:'de_q2_d'}],
        [{text:'D) Gute Nacht',callback:'de_q2_y'}]
      ],
      edges:[
        {target:'de_q2_d',matchType:'exact',value:'de_q2_d',label:'✅'},
        {target:'de_q2_y',matchType:'exact',value:'de_q2_y',label:'❌'}
      ]
    },
    {
      id:'de_q2_d', type:'correct_answer', position:{x:1200,y:1180},
      xpAmount:10, showXPGain:true,
      content:'✅ <b>Richtig! Doğru!</b>\n\n<b>Guten Abend</b> = İyi akşamlar\n\n📅 Almanca Zaman Selamlaşmaları:\n• Guten Morgen = Günaydın (sabah)\n• Guten Tag = İyi günler (gündüz)\n• Guten Abend = İyi akşamlar (akşam)\n• Gute Nacht = İyi geceler (uyumadan önce)\n• Auf Wiedersehen = Görüşürüz (resmi)\n• Tschüss = Hoşça kal (samimi)\n\n+10 XP 🌟',
      edges:[{target:'de_q3',matchType:'always',label:''}]
    },
    {
      id:'de_q2_y', type:'wrong_answer', position:{x:1400,y:1180},
      content:'❌ Doğru: <b>Guten Abend</b> = İyi akşamlar\n\n• Morgen = Sabah → Guten Morgen\n• Tag = Gün → Guten Tag  \n• Abend = Akşam → Guten Abend\n• Nacht = Gece → Gute Nacht',
      edges:[{target:'de_q3',matchType:'always',label:''}]
    },
    {
      id:'de_q3', type:'message', position:{x:1300,y:1340},
      content:'🇩🇪 <b>Soru 3/5 — Almanca Kültür</b>\n\nAlmanya\'ya özgü "Gemütlichkeit" kavramı neyi ifade eder?',
      inlineButtons:[
        [{text:'A) Mükemmeliyetçilik ve verimlilik',callback:'de_q3_y'}],
        [{text:'B) Sıcak, rahat ve dayanışmacı bir atmosfer',callback:'de_q3_d'}],
        [{text:'C) Disiplin ve dakiklik',callback:'de_q3_y'}],
        [{text:'D) Tutumlu ve ekonomik yaşam',callback:'de_q3_y'}]
      ],
      edges:[
        {target:'de_q3_d',matchType:'exact',value:'de_q3_d',label:'✅'},
        {target:'de_q3_y',matchType:'exact',value:'de_q3_y',label:'❌'}
      ]
    },
    {
      id:'de_q3_d', type:'correct_answer', position:{x:1200,y:1520},
      xpAmount:15, showXPGain:true,
      content:'✅ <b>Ausgezeichnet! Mükemmel!</b>\n\n<b>Gemütlichkeit</b> = Sıcak, rahat, huzurlu, samimi atmosfer\n\nBir bira bahçesinde arkadaşlarla geçirilen rahat bir öğleden sonra... Bir kamp ateşi etrafında toplanan aile... Sıcak çikolatanın bulunduğu kütüphane köşesi...\n\nİşte bunların hepsi "Gemütlichkeit"!\n\nAlman kültürünü anlamak için bu kelimeyi bilmek şart. +15 XP 🌟',
      edges:[{target:'de_q4',matchType:'always',label:''}]
    },
    {
      id:'de_q3_y', type:'wrong_answer', position:{x:1400,y:1520},
      content:'❌ Doğru: <b>Sıcak, rahat ve samimi atmosfer</b>\n\nGemütlichkeit = Almanca\'nın "ruhu"nu anlatan kavram.\nBir araya gelme, sıcaklık, rahatlık, huzur...\n\nAlman bira kültürünün temeli de bu kavrama dayanır!',
      edges:[{target:'de_q4',matchType:'always',label:''}]
    },
    {
      id:'de_q4', type:'message', position:{x:1300,y:1680},
      content:'🇩🇪 <b>Soru 4/5 — Sayılar</b>\n\nAlmancada "37" nasıl söylenir?',
      inlineButtons:[
        [{text:'A) Dreißig und sieben',callback:'de_q4_y'}],
        [{text:'B) Siebenunddreißig',callback:'de_q4_d'}],
        [{text:'C) Dreißigsieben',callback:'de_q4_y'}],
        [{text:'D) Sieben dreißig',callback:'de_q4_y'}]
      ],
      edges:[
        {target:'de_q4_d',matchType:'exact',value:'de_q4_d',label:'✅'},
        {target:'de_q4_y',matchType:'exact',value:'de_q4_y',label:'❌'}
      ]
    },
    {
      id:'de_q4_d', type:'correct_answer', position:{x:1200,y:1860},
      xpAmount:15, showXPGain:true,
      content:'✅ <b>Doğru! Siebenunddreißig!</b>\n\n💡 Almancada sayılar Türkçe\'ye benzer biçimde okunur:\n<b>Önce birler, sonra onlar</b>\n\n• 21 = Einundzwanzig (bir-ve-yirmi)\n• 37 = Siebenunddreißig (yedi-ve-otuz)\n• 45 = Fünfundvierzig (beş-ve-kırk)\n• 99 = Neunundneunzig (dokuz-ve-doksan)\n\n+15 XP 🌟',
      edges:[{target:'de_q5',matchType:'always',label:''}]
    },
    {
      id:'de_q4_y', type:'wrong_answer', position:{x:1400,y:1860},
      content:'❌ Doğru: <b>Siebenunddreißig</b>\n\nAlmancada birler + "und" + onlar:\n• Sieben (7) + und + dreißig (30)\n= Siebenunddreißig (37)\n\nYaklaşık Türkçe gibi: "yedi ve otuz"',
      edges:[{target:'de_q5',matchType:'always',label:''}]
    },
    {
      id:'de_q5', type:'message', position:{x:1300,y:2020},
      content:'🇩🇪 <b>Son Soru 5/5 — Ünlü Almanca Alıntı</b>\n\nGoethe\'nin hangi eseri dünya edebiyatının başyapıtları arasında sayılır?',
      inlineButtons:[
        [{text:'A) Faust',callback:'de_q5_d'}],
        [{text:'B) Die Leiden des jungen Werthers',callback:'de_q5_y'}],
        [{text:'C) Wilhelm Meister',callback:'de_q5_y'}],
        [{text:'D) Hepsi başyapıt sayılır',callback:'de_q5_d'}]
      ],
      edges:[
        {target:'de_q5_d',matchType:'exact',value:'de_q5_d',label:'✅'},
        {target:'de_q5_y',matchType:'exact',value:'de_q5_y',label:'❌'}
      ]
    },
    {
      id:'de_q5_d', type:'correct_answer', position:{x:1200,y:2200},
      xpAmount:20, showXPGain:true,
      content:'✅ <b>Brilliant!</b>\n\nAslında Goethe\'nin birden fazla başyapıtı var:\n\n📚 <b>Faust</b> — Felsefenin ve edebiyatın doruk eseri\n📚 <b>Genç Werther\'in Acıları</b> — Romantizm çağının en etkili romanı. 1774\'te yayınlandığında Avrupa\'da "Werther etkisi" adı verilen bir intihar dalgasına yol açtı!\n\nGoethe 82 yıl yaşadı, hayatının son gününe kadar yazdı.\nSon sözü: <i>"Mehr Licht!"</i> (Daha fazla ışık!) 💡\n\n+20 XP Bonus! 🏆',
      edges:[{target:'de_test_son',matchType:'always',label:''}]
    },
    {
      id:'de_q5_y', type:'wrong_answer', position:{x:1400,y:2200},
      content:'❌ Doğru: Hepsi veya özellikle <b>Faust</b>\n\nFaust, şeytan ile anlaşan bir bilginin hikâyesi. Dünya edebiyatının en çok atıfta bulunulan eserleri arasında.\n\n"Genç Werther\'in Acıları" da devrim niteliğinde bir romandı.',
      edges:[{target:'de_test_son',matchType:'always',label:''}]
    },
    {
      id:'de_test_son', type:'message', position:{x:1300,y:2380},
      content:'🇩🇪 <b>Almanca Testi Tamamlandı!</b>\n\n⭐ Seviye: <b>{{level}}</b>\n⚡ XP: <b>{{xp}}</b>\n\n🏆 Almanca öğrenmek seni Avrupa\'nın kalbine açacak!\n\n<b>Bundan sonra ne yapmak istersin?</b>',
      inlineButtons:[
        [{text:'🔁 Testi Tekrar Al',callback:'de_test'},{text:'🧩 İlginç Kelimeler',callback:'de_kelime'}],
        [{text:'👅 Tekerleme Dene',callback:'de_tek'},{text:'🏠 Ana Menü',callback:'ana_menu'}]
      ],
      edges:[
        {target:'de_t1',matchType:'exact',value:'de_test',label:''},
        {target:'de_kelime_msg',matchType:'exact',value:'de_kelime',label:''},
        {target:'de_tek_msg',matchType:'exact',value:'de_tek',label:''},
        {target:'s1',matchType:'always',label:''}
      ]
    },
    {
      id:'de_kelime_msg', type:'message', position:{x:1600,y:480},
      content:'🧩 <b>Almancada Çevrilemeyen Kelimeler</b>\n\nAlmanca birleşik kelimeler sistemiyle gerçekten eşsiz kavramlar üretiyor:\n\n✨ <b>Schadenfreude</b> — Başkasının talihsizliğinden duyulan gizli mutluluk\n<i>Bugün dünyanın her dilinde kullanılıyor!</i>\n\n✨ <b>Weltschmerz</b> — Dünyanın acısını hisseden evrensel keder\n<i>Welt (dünya) + Schmerz (acı)</i>\n\n✨ <b>Fingerspitzengefühl</b> — Parmak ucu hissi; ince sezgi, hassas yargı\n<i>Bir lider için olmazsa olmaz özellik!</i>\n\n✨ <b>Torschlusspanik</b> — Kapının kapanmak üzere olduğunu hissetmek; fırsat kaçıracağım korkusu\n<i>Tor (kapı) + Schluss (kapanış) + Panik</i>\n\n✨ <b>Verschlimmbessern</b> — Bir şeyi düzeltmeye çalışırken daha da kötüleştirmek\n<i>Bunu kim yaşamamış ki?! 😄</i>\n\n✨ <b>Ohrwurm</b> — Kulak kurdu; kafandan çıkmayan şarkı\n<i>Ohr (kulak) + Wurm (kurt)</i>\n\nBu kelimeler için Almanca öğrenmek bile değer! 😊',
      inlineButtons:[
        [{text:'🧪 Test Çöz',callback:'de_test'},{text:'🏠 Ana Menü',callback:'ana_menu'}]
      ],
      edges:[
        {target:'de_t1',matchType:'exact',value:'de_test',label:''},
        {target:'s1',matchType:'always',label:''}
      ]
    },
    {
      id:'de_tek_msg', type:'message', position:{x:1750,y:480},
      content:'👅 <b>Almanca Tekerleme Egzersizi</b>\n\nAlmanca "Sch", "Ch", "Pf" sesleri Türkçe konuşanlar için çok alışılmadık!\n\n🔊 <b>Klasik Almanca Tekerleme:</b>\n<code>Fischers Fritze fischt frische Fische,\nfrische Fische fischt Fischers Fritze.</code>\n<i>(Balıkçı Fritz taze balık tutar,\ntaze balık tutar balıkçı Fritz.)</i>\n\n🔊 <b>Daha Zor:</b>\n<code>Blaukraut bleibt Blaukraut\nund Brautkleid bleibt Brautkleid.</code>\n<i>(Kırmızı lahana kırmızı lahana kalır,\ngelinlik gelinlik kalır.)</i>\n\n🔊 <b>Uzman Seviye:</b>\n<code>Wenn Fliegen hinter Fliegen fliegen,\nfliegen Fliegen Fliegen nach.</code>\n<i>(Sinekler sineklerin arkasından uçtuğunda,\nsinekler sineklerin peşinden uçar.)</i>\n\n💡 Almancada "fliegen" = uçmak, "Fliegen" = sinekler — büyük/küçük harf anlam değiştirir!',
      inlineButtons:[
        [{text:'😅 Çok Zor!',callback:'tek_xp5'},{text:'💪 3-5 kez Söyledim!',callback:'tek_xp10'}],
        [{text:'🔥 Ustayım Ben!',callback:'tek_xp20'},{text:'🏠 Ana Menü',callback:'ana_menu'}]
      ],
      edges:[
        {target:'en_tek_xp5',matchType:'exact',value:'tek_xp5',label:''},
        {target:'en_tek_xp10',matchType:'exact',value:'tek_xp10',label:''},
        {target:'en_tek_xp20',matchType:'exact',value:'tek_xp20',label:''},
        {target:'s1',matchType:'always',label:''}
      ]
    },
    {
      id:'de_sozler_msg', type:'message', position:{x:1900,y:480},
      content:'📖 <b>Alman Düşünürlerinden İlham Veren Sözler</b>\n\n💭 <b>Goethe:</b>\n<i>"Bir insan yalnızca bildiği kadar görür."</i>\n\n💭 <b>Nietzsche:</b>\n<i>"Seni öldürmeyen şey seni güçlendirir."</i>\n\n💭 <b>Kant:</b>\n<i>"İki şey beni dolduruyor: Üzerimdeki yıldızlı gökyüzü ve içimdeki ahlak yasası."</i>\n\n💭 <b>Schiller:</b>\n<i>"İnsan ancak oynadığı zaman insandır."</i>\n\n💭 <b>Hegel:</b>\n<i>"Tarihin tek öğrettiği şey, insanların tarihten hiçbir şey öğrenmediğidir."</i>\n\n💭 <b>Einstein (Almanca düşünürdü!):</b>\n<i>"Hayal gücü bilgiden önemlidir."</i>\n\n💭 <b>Almanca Halk Sözü:</b>\n<i>"Übung macht den Meister"</i> = Pratik ustayı yapar\n\nBu sözlerin aslını Almancada okumak için başlıyalım! 📚',
      inlineButtons:[
        [{text:'🧪 Test Çöz',callback:'de_test'},{text:'🏠 Ana Menü',callback:'ana_menu'}]
      ],
      edges:[
        {target:'de_t1',matchType:'exact',value:'de_test',label:''},
        {target:'s1',matchType:'always',label:''}
      ]
    },

    // ══════════════════════════════════════════
    // RUSÇA — ÖZET (daha kısa ama içerikli)
    // ══════════════════════════════════════════
    {
      id:'ru_menu', type:'message', position:{x:2200,y:260},
      content:'🇷🇺 <b>Rusça — Slav Dillerinin Büyük Abisi</b>\n\n📊 <b>Rusça Hakkında:</b>\n• Ana dil konuşucusu: 150 milyon\n• İkinci dil olarak: 110 milyon\n• BDT\'de lingua franca (ortak dil)\n• Resmi BM dili (6 resmi dilden biri)\n• Uzayda konuşulan dillerden biri!\n\n🚀 <b>İlginç Gerçek:</b>\nUluslararası Uzay İstasyonu\'nda (ISS) iki resmi dil var: İngilizce ve Rusça. Her astronot her iki dili de öğrenmek zorunda!\n\n🔤 <b>Kiril Alfabesi:</b>\nRusça Latin alfabesi değil Kiril alfabesi kullanır. 33 harf var ve birçoğu Latin\'e benziyor:\n• А, Е, О, Т, М — aynı ses\n• В = V, Н = N, Р = R, С = S, Х = H\n• Farklı görünen: Ж, Ш, Щ, Ч, Ю, Я\n\n👇 <b>Ne yapmak istersin?</b>',
      inlineButtons:[
        [{text:'🧪 Test Çöz (4 Soru)',callback:'ru_test'},{text:'🔡 Kiril Alfabesi Rehberi',callback:'ru_alfabe'}],
        [{text:'🗣️ Günlük Cümleler',callback:'ru_cumle'},{text:'🏠 Ana Menü',callback:'ana_menu'}]
      ],
      edges:[
        {target:'ru_t1',matchType:'exact',value:'ru_test',label:''},
        {target:'ru_alfabe_msg',matchType:'exact',value:'ru_alfabe',label:''},
        {target:'ru_cumle_msg',matchType:'exact',value:'ru_cumle',label:''},
        {target:'s1',matchType:'exact',value:'ana_menu',label:''}
      ]
    },
    {id:'ru_t1', type:'message', position:{x:2100,y:480},
     content:'🇷🇺 <b>Rusça Testi Başlıyor!</b>\n\n4 soru, her doğru +15 XP\nHazır mısın?',
     inlineButtons:[[{text:'✅ Başlat!',callback:'baslat_ru'}]],
     edges:[{target:'ru_q1',matchType:'always',label:''}]},
    {id:'ru_q1', type:'message', position:{x:2100,y:640},
     content:'🇷🇺 <b>Soru 1/4</b>\n\n"<b>Привет</b>" (Privet) ne anlama gelir?',
     inlineButtons:[
       [{text:'A) Merhaba (samimi)',callback:'ru_q1_d'}],
       [{text:'B) Günaydın',callback:'ru_q1_y'}],
       [{text:'C) İyi akşamlar',callback:'ru_q1_y'}],
       [{text:'D) Hoşça kal',callback:'ru_q1_y'}]
     ],
     edges:[
       {target:'ru_q1_d_node',matchType:'exact',value:'ru_q1_d',label:'✅'},
       {target:'ru_q1_y_node',matchType:'exact',value:'ru_q1_y',label:'❌'}
     ]},
    {id:'ru_q1_d_node', type:'correct_answer', position:{x:2000,y:820}, xpAmount:15, showXPGain:true,
     content:'✅ <b>Правильно! Doğru!</b>\n\nПривет = Privet = Merhaba (samimi)\n\nResmi hali: Здравствуйте (Zdravstvuyte) — çok uzun değil mi? 😄\n\nRusça selamlama düzeyleri:\n• Привет — arkadaşlar arası\n• Здравствуй — tek kişiye resmi\n• Здравствуйте — birden fazla kişiye veya resmi\n\n+15 XP 🌟', edges:[{target:'ru_q2',matchType:'always',label:''}]},
    {id:'ru_q1_y_node', type:'wrong_answer', position:{x:2200,y:820},
     content:'❌ Doğru: <b>Merhaba (samimi)</b>\n\nПривет = Privet = Merhaba\nRusların günlük samimi selamlama şekli.', edges:[{target:'ru_q2',matchType:'always',label:''}]},
    {id:'ru_q2', type:'message', position:{x:2100,y:980},
     content:'🇷🇺 <b>Soru 2/4</b>\n\n"<b>Спасибо</b>" (Spasibo) ne anlama gelir?',
     inlineButtons:[
       [{text:'A) Lütfen',callback:'ru_q2_y'}],
       [{text:'B) Teşekkür ederim',callback:'ru_q2_d'}],
       [{text:'C) Özür dilerim',callback:'ru_q2_y'}],
       [{text:'D) Evet',callback:'ru_q2_y'}]
     ],
     edges:[
       {target:'ru_q2_d_node',matchType:'exact',value:'ru_q2_d',label:'✅'},
       {target:'ru_q2_y_node',matchType:'exact',value:'ru_q2_y',label:'❌'}
     ]},
    {id:'ru_q2_d_node', type:'correct_answer', position:{x:2000,y:1160}, xpAmount:15, showXPGain:true,
     content:'✅ Доğru!\n\nСпасибо = Spasibo = Teşekkür ederim\n\nVe karşılık: Пожалуйста (Pozhaluysta) = Rica ederim\n\nTemel kelimeler:\n• Да (Da) = Evet\n• Нет (Net) = Hayır\n• Пожалуйста = Rica ederim / Lütfen\n\n+15 XP', edges:[{target:'ru_q3',matchType:'always',label:''}]},
    {id:'ru_q2_y_node', type:'wrong_answer', position:{x:2200,y:1160},
     content:'❌ Спасибо = Teşekkür ederim\n\nPozhaluysta = Rica ederim\nDa = Evet, Net = Hayır', edges:[{target:'ru_q3',matchType:'always',label:''}]},
    {id:'ru_q3', type:'message', position:{x:2100,y:1320},
     content:'🇷🇺 <b>Soru 3/4 — Rusya Kültürü</b>\n\nRusya\'da yeni bir eve giden misafir geleneksel olarak ne götürür?',
     inlineButtons:[
       [{text:'A) Ekmek ve tuz',callback:'ru_q3_d'}],
       [{text:'B) Çiçek ve şarap',callback:'ru_q3_y'}],
       [{text:'C) Vodka ve peynir',callback:'ru_q3_y'}],
       [{text:'D) Tatlı ve meyve',callback:'ru_q3_y'}]
     ],
     edges:[
       {target:'ru_q3_d_node',matchType:'exact',value:'ru_q3_d',label:'✅'},
       {target:'ru_q3_y_node',matchType:'exact',value:'ru_q3_y',label:'❌'}
     ]},
    {id:'ru_q3_d_node', type:'correct_answer', position:{x:2000,y:1500}, xpAmount:15, showXPGain:true,
     content:'✅ <b>Doğru! Ekmek ve Tuz!</b>\n\n🍞🧂 Rus geleneğinde yeni bir eve taşınan birine ekmek ve tuz getirmek bolluk ve sıcaklık simgesidir.\n\nBu gelenek Rusça\'da "хлеб-соль" (Hleb-sol = Ekmek-Tuz) olarak adlandırılır ve yüzyıllardır sürer.\n\nRus misafirperverliği dünyaca ünlüdür! +15 XP 🌟', edges:[{target:'ru_q4',matchType:'always',label:''}]},
    {id:'ru_q3_y_node', type:'wrong_answer', position:{x:2200,y:1500},
     content:'❌ Doğru: <b>Ekmek ve Tuz</b>\n\nRus geleneğinde (хлеб-соль) yeni eve taşınana ekmek ve tuz götürülür.\nBolluk ve sıcaklık simgesi!', edges:[{target:'ru_q4',matchType:'always',label:''}]},
    {id:'ru_q4', type:'message', position:{x:2100,y:1660},
     content:'🇷🇺 <b>Son Soru 4/4</b>\n\nRusça\'da "Я тебя люблю" (Ya tebya lyublyu) ne anlama gelir?',
     inlineButtons:[
       [{text:'A) Seni seviyorum',callback:'ru_q4_d'}],
       [{text:'B) Güle güle',callback:'ru_q4_y'}],
       [{text:'C) Seni özledim',callback:'ru_q4_y'}],
       [{text:'D) Teşekkür ederim',callback:'ru_q4_y'}]
     ],
     edges:[
       {target:'ru_q4_d_node',matchType:'exact',value:'ru_q4_d',label:'✅'},
       {target:'ru_q4_y_node',matchType:'exact',value:'ru_q4_y',label:'❌'}
     ]},
    {id:'ru_q4_d_node', type:'correct_answer', position:{x:2000,y:1840}, xpAmount:20, showXPGain:true,
     content:'✅ <b>Великолепно! Mükemmel!</b>\n\nЯ тебя люблю = Seni seviyorum\n\n• Я (Ya) = Ben\n• тебя (tebya) = seni\n• люблю (lyublyu) = seviyorum\n\nRusça kelime sırası esnek olabilir:\nЯ люблю тебя de doğru! +20 XP 🌹', edges:[{target:'ru_test_son',matchType:'always',label:''}]},
    {id:'ru_q4_y_node', type:'wrong_answer', position:{x:2200,y:1840},
     content:'❌ Doğru: <b>Seni seviyorum</b>\n\nЯ тебя люблю = Ya tebya lyublyu\nRomantik Rusça öğrendin! 🌹', edges:[{target:'ru_test_son',matchType:'always',label:''}]},
    {id:'ru_test_son', type:'message', position:{x:2100,y:2020},
     content:'🇷🇺 <b>Rusça Testi Bitti!</b>\n\nXP: <b>{{xp}}</b> | Level: <b>{{level}}</b>\n\nRusça öğrenmek 9 ülkede kapılar açar! 🌍',
     inlineButtons:[
       [{text:'🔁 Tekrar',callback:'ru_test'},{text:'🗣️ Cümleler',callback:'ru_cumle'}],
       [{text:'🏠 Ana Menü',callback:'ana_menu'}]
     ],
     edges:[
       {target:'ru_t1',matchType:'exact',value:'ru_test',label:''},
       {target:'ru_cumle_msg',matchType:'exact',value:'ru_cumle',label:''},
       {target:'s1',matchType:'always',label:''}
     ]},
    {id:'ru_alfabe_msg', type:'message', position:{x:2300,y:480},
     content:'🔡 <b>Kiril Alfabesi Rehberi</b>\n\n<b>Latin\'e benzeyen harfler:</b>\nА=A, Е=Ye, К=K, М=M, О=O, Т=T\n\n<b>Farklı okunuşlu benzer harfler:</b>\nВ=V, Н=N, Р=R, С=S, Х=H\n\n<b>Tamamen farklı harfler:</b>\nБ=B, Г=G, Д=D, З=Z, И=İ\nЛ=L, П=P, Ф=F, Ц=Ts, Ч=Ch\nШ=Sh, Щ=Shch, Ю=Yu, Я=Ya\n\n<b>Özel işaretler:</b>\nЪ = Sert işaret (önceki hardin sesini sertleştirir)\nЬ = Yumuşak işaret (önceki harfin sesini yumuşatır)\n\n💡 <b>Hızlı Öğrenme Trick\'i:</b>\nKirilin yarısından fazlası zaten tanıdık.\nSadece БАНК yazısını okuyabilirsin: BANK!',
     inlineButtons:[
       [{text:'🧪 Test Et',callback:'ru_test'},{text:'🏠 Menü',callback:'ana_menu'}]
     ],
     edges:[
       {target:'ru_t1',matchType:'exact',value:'ru_test',label:''},
       {target:'s1',matchType:'always',label:''}
     ]},
    {id:'ru_cumle_msg', type:'message', position:{x:2450,y:480},
     content:'🗣️ <b>Günlük Rusça Cümleler</b>\n\n<b>Selamlaşma:</b>\n• Привет! = Merhaba! (samimi)\n• Здравствуйте! = İyi günler! (resmi)\n• Как дела? = Nasılsın?\n• Хорошо, спасибо = İyi, teşekkürler\n\n<b>Temel İhtiyaçlar:</b>\n• Где туалет? = Tuvalet nerede?\n• Сколько стоит? = Ne kadar?\n• Я не понимаю = Anlamıyorum\n• Говорите медленнее = Yavaş konuşun\n• Помогите! = Yardım edin!\n\n<b>Yemek:</b>\n• Вкусно! = Lezzetli!\n• Счёт, пожалуйста = Hesap lütfen\n• Без мяса = Etsiz\n\n<b>Sayılar:</b>\n1=один, 2=два, 3=три, 4=четыре, 5=пять',
     inlineButtons:[
       [{text:'🧪 Test',callback:'ru_test'},{text:'🏠 Menü',callback:'ana_menu'}]
     ],
     edges:[
       {target:'ru_t1',matchType:'exact',value:'ru_test',label:''},
       {target:'s1',matchType:'always',label:''}
     ]},

    // ══════════════════════════════════════════
    // FRANSIZCA — ÖZET
    // ══════════════════════════════════════════
    {
      id:'fr_menu', type:'message', position:{x:2800,y:260},
      content:'🇫🇷 <b>Fransızca — Diplomasinin ve Aşkın Dili</b>\n\n📊 <b>Fransızca Hakkında:</b>\n• Ana dil: 80 milyon konuşucu\n• Toplam konuşucu: 300+ milyon, 5 kıta\n• BM\'nin 2 çalışma dilinden biri\n• En çok çevrilen 3. dil (İngilizce ve Almancanın ardından)\n• Moda, yemek, sanat ve diplomaside uluslararası standart dil\n\n🥐 <b>Fransızca Olmadan Dünya:</b>\nMenü kavramı yoktu. "Restaurant" kelimesi yoktu. "Ballet", "cinema", "chauffeur", "café", "boutique" yoktu. Fransızcadan alınan bu kelimeler İngilizce başta olmak üzere pek çok dile geçti.\n\n🗼 <b>Kültürel Etki:</b>\n19. yüzyılda Fransızca diplomaside o kadar baskındı ki Osmanlı Sarayı dahi uluslararası yazışmalarda Fransızca kullanıyordu!\n\n👇 <b>Ne yapmak istersin?</b>',
      inlineButtons:[
        [{text:'🧪 Test Çöz (4 Soru)',callback:'fr_test'},{text:'💬 Temel Cümleler',callback:'fr_cumle'}],
        [{text:'🍷 Fransız Kültürü',callback:'fr_kultur'},{text:'🏠 Ana Menü',callback:'ana_menu'}]
      ],
      edges:[
        {target:'fr_t1',matchType:'exact',value:'fr_test',label:''},
        {target:'fr_cumle_msg',matchType:'exact',value:'fr_cumle',label:''},
        {target:'fr_kultur_msg',matchType:'exact',value:'fr_kultur',label:''},
        {target:'s1',matchType:'exact',value:'ana_menu',label:''}
      ]
    },
    {id:'fr_t1', type:'message', position:{x:2700,y:480},
     content:'🇫🇷 <b>Fransızca Testi Başlıyor!</b>\n\n4 soru + Kültür soruları\nHer doğru +15 XP',
     inlineButtons:[[{text:'✅ Allons-y! (Gidelim!)',callback:'baslat_fr'}]],
     edges:[{target:'fr_q1',matchType:'always',label:''}]},
    {id:'fr_q1', type:'message', position:{x:2700,y:640},
     content:'🇫🇷 <b>Soru 1/4</b>\n\n"<b>Je t\'aime</b>" ne anlama gelir?',
     inlineButtons:[
       [{text:'A) Seni seviyorum',callback:'fr_q1_d'}],
       [{text:'B) Günaydın',callback:'fr_q1_y'}],
       [{text:'C) Teşekkürler',callback:'fr_q1_y'}],
       [{text:'D) Hoşça kal',callback:'fr_q1_y'}]
     ],
     edges:[
       {target:'fr_q1_d_node',matchType:'exact',value:'fr_q1_d',label:'✅'},
       {target:'fr_q1_y_node',matchType:'exact',value:'fr_q1_y',label:'❌'}
     ]},
    {id:'fr_q1_d_node', type:'correct_answer', position:{x:2600,y:820}, xpAmount:15, showXPGain:true,
     content:'✅ <b>Magnifique!</b>\n\nJe t\'aime = Seni seviyorum\n\nDünyanın en romantik cümlesi diye anılır.\nJe (ben) + t\'aime (aime = sevmek, t = seni)\n\nDaha güçlü hali: "Je t\'aime de tout mon cœur"\n= Tüm kalbimle seni seviyorum 💕\n\n+15 XP 🌹', edges:[{target:'fr_q2',matchType:'always',label:''}]},
    {id:'fr_q1_y_node', type:'wrong_answer', position:{x:2800,y:820},
     content:'❌ Doğru: <b>Seni seviyorum</b>\n\nJe = Ben, aime = sevmek\nt\' = seni (te\'nin kısaltması)\n\nJe t\'aime — Dünyanın en güzel üç kelimesi! 💕', edges:[{target:'fr_q2',matchType:'always',label:''}]},
    {id:'fr_q2', type:'message', position:{x:2700,y:980},
     content:'🇫🇷 <b>Soru 2/4 — Fransızca Kültür</b>\n\nFransız "bise" geleneği nedir?',
     inlineButtons:[
       [{text:'A) Yanaktan öpüşerek selamlaşma',callback:'fr_q2_d'}],
       [{text:'B) El sıkışarak selamlaşma',callback:'fr_q2_y'}],
       [{text:'C) Başı eğerek selamlaşma',callback:'fr_q2_y'}],
       [{text:'D) Sarılarak selamlaşma',callback:'fr_q2_y'}]
     ],
     edges:[
       {target:'fr_q2_d_node',matchType:'exact',value:'fr_q2_d',label:'✅'},
       {target:'fr_q2_y_node',matchType:'exact',value:'fr_q2_y',label:'❌'}
     ]},
    {id:'fr_q2_d_node', type:'correct_answer', position:{x:2600,y:1160}, xpAmount:15, showXPGain:true,
     content:'✅ <b>Très bien! Çok iyi!</b>\n\n<b>La bise</b> = Yanaktan öpüşerek selamlaşma\n\nFransa\'da bölgeye göre farklılaşır:\n• Paris: 2 öpücük\n• Güney Fransa: 3 öpücük\n• Bazı bölgeler: 4 öpücük!\n\nKısacası Fransa\'da doğru öpücük sayısını bilmek önemli 😄\n\n+15 XP 🌟', edges:[{target:'fr_q3',matchType:'always',label:''}]},
    {id:'fr_q2_y_node', type:'wrong_answer', position:{x:2800,y:1160},
     content:'❌ Doğru: <b>Yanaktan öpüşerek selamlaşma</b>\n\nFransa\'da "la bise" geleneği: Yanağı yanağa koyarak selamlaşmak.\nBölgeye göre 2-4 öpücük!', edges:[{target:'fr_q3',matchType:'always',label:''}]},
    {id:'fr_q3', type:'message', position:{x:2700,y:1320},
     content:'🇫🇷 <b>Soru 3/4 — Temel Fransızca</b>\n\n"Merci beaucoup" ne anlama gelir?',
     inlineButtons:[
       [{text:'A) Çok teşekkür ederim',callback:'fr_q3_d'}],
       [{text:'B) Rica ederim',callback:'fr_q3_y'}],
       [{text:'C) Günaydın',callback:'fr_q3_y'}],
       [{text:'D) Affedersiniz',callback:'fr_q3_y'}]
     ],
     edges:[
       {target:'fr_q3_d_node',matchType:'exact',value:'fr_q3_d',label:'✅'},
       {target:'fr_q3_y_node',matchType:'exact',value:'fr_q3_y',label:'❌'}
     ]},
    {id:'fr_q3_d_node', type:'correct_answer', position:{x:2600,y:1500}, xpAmount:10, showXPGain:true,
     content:'✅ Doğru!\n\nMerci = Teşekkürler\nBeaucoup = Çok\nMerci beaucoup = Çok teşekkür ederim\n\nKarşılık: De rien = Rica ederim\nDaha resmi: Je vous en prie = Buyurun +10 XP', edges:[{target:'fr_q4',matchType:'always',label:''}]},
    {id:'fr_q3_y_node', type:'wrong_answer', position:{x:2800,y:1500},
     content:'❌ Merci beaucoup = Çok teşekkür ederim\nMerci = Teşekkürler, Beaucoup = Çok', edges:[{target:'fr_q4',matchType:'always',label:''}]},
    {id:'fr_q4', type:'message', position:{x:2700,y:1660},
     content:'🇫🇷 <b>Son Soru 4/4 — Fransız Mutfağı</b>\n\nHangi yemek Fransız mutfağından tüm dünyaya yayılmıştır?',
     inlineButtons:[
       [{text:'A) Sushi',callback:'fr_q4_y'}],
       [{text:'B) Croissant ve Crêpe',callback:'fr_q4_d'}],
       [{text:'C) Pizza',callback:'fr_q4_y'}],
       [{text:'D) Spaghetti',callback:'fr_q4_y'}]
     ],
     edges:[
       {target:'fr_q4_d_node',matchType:'exact',value:'fr_q4_d',label:'✅'},
       {target:'fr_q4_y_node',matchType:'exact',value:'fr_q4_y',label:'❌'}
     ]},
    {id:'fr_q4_d_node', type:'correct_answer', position:{x:2600,y:1840}, xpAmount:20, showXPGain:true,
     content:'✅ <b>Bravo! Mükemmel!</b>\n\nFransız mutfağı UNESCO Kültürel Miras listesinde!\n\n🥐 Croissant — Sabah kahvaltısının vazgeçilmezi\n🥞 Crêpe — İnce gözleme, tatlı veya tuzlu\n🧀 Brie, Camembert — 1000\'den fazla peynir çeşidi\n🍷 Fransa dünyanın en iyi şaraplarını üretiyor\n🎂 Bûche de Noël, Macaron, Éclair...\n\n+20 XP! 🍷', edges:[{target:'fr_test_son',matchType:'always',label:''}]},
    {id:'fr_q4_y_node', type:'wrong_answer', position:{x:2800,y:1840},
     content:'❌ Doğru: <b>Croissant ve Crêpe</b>\n\nFransız mutfağı dünyayı etkiledi!\nCroissant, crêpe, macaron, éclair hepsi Fransız!\nFransız mutfağı UNESCO listesinde.', edges:[{target:'fr_test_son',matchType:'always',label:''}]},
    {id:'fr_test_son', type:'message', position:{x:2700,y:2020},
     content:'🇫🇷 <b>Fransızca Testi Tamamlandı!</b>\n\nXP: <b>{{xp}}</b> | Level: <b>{{level}}</b>\n\n<i>C\'est la vie!</i> Hayat böyle! 🥂',
     inlineButtons:[
       [{text:'🔁 Tekrar',callback:'fr_test'},{text:'🍷 Kültür',callback:'fr_kultur'}],
       [{text:'🏠 Ana Menü',callback:'ana_menu'}]
     ],
     edges:[
       {target:'fr_t1',matchType:'exact',value:'fr_test',label:''},
       {target:'fr_kultur_msg',matchType:'exact',value:'fr_kultur',label:''},
       {target:'s1',matchType:'always',label:''}
     ]},
    {id:'fr_cumle_msg', type:'message', position:{x:2950,y:480},
     content:'💬 <b>Temel Fransızca — Hayatta Kalma Rehberi</b>\n\n<b>Selamlaşma:</b>\n• Bonjour = Günaydın/Merhaba\n• Bonsoir = İyi akşamlar\n• Au revoir = Görüşürüz\n• Salut! = Selam! (samimi)\n\n<b>Kibarlık:</b>\n• Merci = Teşekkürler\n• De rien = Rica ederim\n• S\'il vous plaît = Lütfen (resmi)\n• Excusez-moi = Affedersiniz\n• Pardon = Özür dilerim\n\n<b>Yardım İsteme:</b>\n• Où est...? = ...nerede?\n• Je ne comprends pas = Anlamıyorum\n• Parlez-vous anglais? = İngilizce biliyor musunuz?\n• Pouvez-vous m\'aider? = Yardım edebilir misiniz?\n\n<b>Alışveriş:</b>\n• Combien ça coûte? = Ne kadar?\n• C\'est trop cher = Çok pahalı\n• L\'addition, s\'il vous plaît = Hesap lütfen',
     inlineButtons:[
       [{text:'🧪 Test',callback:'fr_test'},{text:'🏠 Menü',callback:'ana_menu'}]
     ],
     edges:[
       {target:'fr_t1',matchType:'exact',value:'fr_test',label:''},
       {target:'s1',matchType:'always',label:''}
     ]},
    {id:'fr_kultur_msg', type:'message', position:{x:3100,y:480},
     content:'🍷 <b>Fransız Kültüründen İlginç Bilgiler</b>\n\n🥖 <b>Ekmek Kültürü:</b>\nFransızlar yılda kişi başı 58 kg ekmek yer. Günlük taze baguette almak bir kültürdür. Yasaya göre fırıncılar belirli günler kapatamaz!\n\n🎨 <b>Sanat Mirası:</b>\nLouvre 480.000 eser barındırıyor, hepsini görmek için 35 gün gerekir. Monet, Renoir, Degas, Matisse — tüm Empresyonizm Fransa\'da doğdu.\n\n⏱️ <b>Fransız Saati:</b>\nFransızlar randevulara 15-20 dakika geç gelmekle ünlüdür. Buna "quart d\'heure français" (Fransız çeyrek saati) denir!\n\n🚬 <b>Kafe Kültürü:</b>\nParis\'te 1.800\'den fazla kafe var. Voltaire, Hemingway, Sartre, Picasso — hepsi Paris kafelerinde çalışmış!\n\n💄 <b>Moda Başkenti:</b>\nChanel, Louis Vuitton, Dior, Givenchy, Hermès — dünya modasının %40\'ı Fransa kaynaklı.',
     inlineButtons:[
       [{text:'🧪 Test',callback:'fr_test'},{text:'🏠 Menü',callback:'ana_menu'}]
     ],
     edges:[
       {target:'fr_t1',matchType:'exact',value:'fr_test',label:''},
       {target:'s1',matchType:'always',label:''}
     ]},

    // ══════════════════════════════════════════
    // İSPANYOLCA — ÖZET
    // ══════════════════════════════════════════
    {
      id:'es_menu', type:'message', position:{x:3400,y:260},
      content:'🇪🇸 <b>İspanyolca — Büyüyen Dünyanın Dili</b>\n\n📊 <b>İspanyolca Hakkında:</b>\n• Ana dil konuşucusu: 485+ milyon\n• İkinci dil dahil: 600+ milyon\n• Resmi dil: 21 ülke\n• 2050\'de dünyada en çok konuşulan dil olması bekleniyor\n• ABD\'de 41 milyon ana dil konuşucusu (İspanya\'dan daha fazla!)\n\n🌮 <b>İspanyolca Neden Önemli?</b>\nLatin Amerika, dünyanın en hızlı büyüyen ekonomileri arasında. Brezilya hariç tüm Güney Amerika\'da İspanyolca konuşuluyor. Ayrıca İspanyolca sahneye çıkıyor: Netflix, Amazon, Disney+ Latin Amerika yapımları küresel hit!\n\n🎭 <b>Kültürel Zenginlik:</b>\nGabriel García Márquez, Pablo Neruda, Miguel de Cervantes — edebiyat devleri. Flamenco, Tango (Arjantin), Salsa — ritim dünyaya İspanyolca\'dan yayıldı!\n\n👇 <b>Ne yapmak istersin?</b>',
      inlineButtons:[
        [{text:'🧪 Test Çöz (4 Soru)',callback:'es_test'},{text:'🎵 Müzikle Öğren',callback:'es_muzik'}],
        [{text:'💬 Temel Cümleler',callback:'es_cumle'},{text:'🌮 Latin Amerika Kültürü',callback:'es_kultur'}],
        [{text:'🏠 Ana Menü',callback:'ana_menu'}]
      ],
      edges:[
        {target:'es_t1',matchType:'exact',value:'es_test',label:''},
        {target:'es_muzik_msg',matchType:'exact',value:'es_muzik',label:''},
        {target:'es_cumle_msg',matchType:'exact',value:'es_cumle',label:''},
        {target:'es_kultur_msg',matchType:'exact',value:'es_kultur',label:''},
        {target:'s1',matchType:'exact',value:'ana_menu',label:''}
      ]
    },
    {id:'es_t1', type:'message', position:{x:3300,y:480},
     content:'🇪🇸 <b>İspanyolca Testi!</b>\n\n4 soru, her doğru +15 XP\n¡Buena suerte! (İyi şanslar!)',
     inlineButtons:[[{text:'✅ ¡Vamos! (Hadi!)',callback:'baslat_es'}]],
     edges:[{target:'es_q1',matchType:'always',label:''}]},
    {id:'es_q1', type:'message', position:{x:3300,y:640},
     content:'🇪🇸 <b>Soru 1/4</b>\n\n"<b>¿Cómo estás?</b>" ne anlama gelir?',
     inlineButtons:[
       [{text:'A) Nasılsın?',callback:'es_q1_d'}],
       [{text:'B) Adın ne?',callback:'es_q1_y'}],
       [{text:'C) Nerelisin?',callback:'es_q1_y'}],
       [{text:'D) Kaç yaşındasın?',callback:'es_q1_y'}]
     ],
     edges:[
       {target:'es_q1_d_node',matchType:'exact',value:'es_q1_d',label:'✅'},
       {target:'es_q1_y_node',matchType:'exact',value:'es_q1_y',label:'❌'}
     ]},
    {id:'es_q1_d_node', type:'correct_answer', position:{x:3200,y:820}, xpAmount:15, showXPGain:true,
     content:'✅ <b>¡Perfecto!</b>\n\n¿Cómo estás? = Nasılsın?\n¡Muy bien, gracias! = Çok iyiyim, teşekkürler!\n\n• ¿Cómo te llamas? = Adın ne?\n• ¿De dónde eres? = Nerelisin?\n• ¿Cuántos años tienes? = Kaç yaşındasın?\n\n+15 XP 🌟', edges:[{target:'es_q2',matchType:'always',label:''}]},
    {id:'es_q1_y_node', type:'wrong_answer', position:{x:3400,y:820},
     content:'❌ Doğru: <b>Nasılsın?</b>\n\n¿Cómo estás? = Nasılsın?\n¿Cómo te llamas? = Adın ne?\n¿De dónde eres? = Nerelisin?', edges:[{target:'es_q2',matchType:'always',label:''}]},
    {id:'es_q2', type:'message', position:{x:3300,y:980},
     content:'🇪🇸 <b>Soru 2/4 — Kültür</b>\n\nİspanya\'ya özgü öğleden sonra dinlencesi hangi isimle bilinir?',
     inlineButtons:[
       [{text:'A) Siesta',callback:'es_q2_d'}],
       [{text:'B) Fiesta',callback:'es_q2_y'}],
       [{text:'C) Pasta',callback:'es_q2_y'}],
       [{text:'D) Mañana',callback:'es_q2_y'}]
     ],
     edges:[
       {target:'es_q2_d_node',matchType:'exact',value:'es_q2_d',label:'✅'},
       {target:'es_q2_y_node',matchType:'exact',value:'es_q2_y',label:'❌'}
     ]},
    {id:'es_q2_d_node', type:'correct_answer', position:{x:3200,y:1160}, xpAmount:15, showXPGain:true,
     content:'✅ <b>¡Muy bien! Çok iyi!</b>\n\n<b>Siesta</b> = Öğleden sonra kısa uyku\n\n🕐 Geleneksel olarak 14:00-17:00 arası\nBilimsel araştırmalar 20-30 dakika öğlen uykusunun:\n✅ Üretkenliği %34 artırdığını\n✅ Hafızayı güçlendirdiğini\n✅ Kalp hastalığı riskini azalttığını gösteriyor!\n\n+15 XP 😴✨', edges:[{target:'es_q3',matchType:'always',label:''}]},
    {id:'es_q2_y_node', type:'wrong_answer', position:{x:3400,y:1160},
     content:'❌ Doğru: <b>Siesta</b>\n\nSiesta = Öğleden sonra kısa uyku geleneği\nFiesta = Parti, şenlik\nMañana = Yarın (ya da "sonra...")', edges:[{target:'es_q3',matchType:'always',label:''}]},
    {id:'es_q3', type:'message', position:{x:3300,y:1320},
     content:'🇪🇸 <b>Soru 3/4 — Edebiyat</b>\n\nDünyanın ilk modern romanı kabul edilen ve İspanyolca yazılmış eser hangisidir?',
     inlineButtons:[
       [{text:'A) Don Kişot (Don Quijote)',callback:'es_q3_d'}],
       [{text:'B) Romeo ve Juliet',callback:'es_q3_y'}],
       [{text:'C) Yüz Yıllık Yalnızlık',callback:'es_q3_y'}],
       [{text:'D) Sefiller',callback:'es_q3_y'}]
     ],
     edges:[
       {target:'es_q3_d_node',matchType:'exact',value:'es_q3_d',label:'✅'},
       {target:'es_q3_y_node',matchType:'exact',value:'es_q3_y',label:'❌'}
     ]},
    {id:'es_q3_d_node', type:'correct_answer', position:{x:3200,y:1500}, xpAmount:20, showXPGain:true,
     content:'✅ <b>¡Excelente! Harika!</b>\n\n<b>Don Quijote de la Mancha</b> — Miguel de Cervantes, 1605\n\n📚 Bu eser neden önemli?\n• Dünyanın ilk modern romanı\n• Dünyanın en çok çevrilen 2. kitabı (Kutsal Kitap\'tan sonra)\n• "Quijote" ve "quijotesco" dünya dillerine girdi\n• "Yel değirmenlerine savaş açmak" deyimi buradan\n\n+20 XP 🌟', edges:[{target:'es_q4',matchType:'always',label:''}]},
    {id:'es_q3_y_node', type:'wrong_answer', position:{x:3400,y:1500},
     content:'❌ Doğru: <b>Don Quijote de la Mancha</b>\n\nCervantes\'in 1605\'te yazdığı bu roman dünyanın ilk modern romanı ve en çok çevrilen 2. kitap!\n"Yel değirmenlerine savaş açmak" buradan geliyor.', edges:[{target:'es_q4',matchType:'always',label:''}]},
    {id:'es_q4', type:'message', position:{x:3300,y:1660},
     content:'🇪🇸 <b>Son Soru 4/4</b>\n\nGünde kaç kişi İspanyolcayı anadil olarak öğreniyor (yaklaşık)?',
     inlineButtons:[
       [{text:'A) Yaklaşık 300 kişi',callback:'es_q4_y'}],
       [{text:'B) Yaklaşık 3.000 kişi',callback:'es_q4_y'}],
       [{text:'C) Yaklaşık 30.000 kişi',callback:'es_q4_d'}],
       [{text:'D) Yaklaşık 300.000 kişi',callback:'es_q4_y'}]
     ],
     edges:[
       {target:'es_q4_d_node',matchType:'exact',value:'es_q4_d',label:'✅'},
       {target:'es_q4_y_node',matchType:'exact',value:'es_q4_y',label:'❌'}
     ]},
    {id:'es_q4_d_node', type:'correct_answer', position:{x:3200,y:1840}, xpAmount:15, showXPGain:true,
     content:'✅ <b>Doğru!</b>\n\nGünde yaklaşık 30.000 çocuk İspanyolcayı anadil olarak öğreniyor!\n\nBu rakamla İspanyolca 2050\'ye kadar dünyada en çok konuşulan dil olabilir.\n\nŞimdiden öğrenmek büyük avantaj sağlar! +15 XP 🌟', edges:[{target:'es_test_son',matchType:'always',label:''}]},
    {id:'es_q4_y_node', type:'wrong_answer', position:{x:3400,y:1840},
     content:'❌ Doğru: <b>~30.000 kişi/gün</b>\n\nİspanyolca inanılmaz hızda büyüyor!\n2050\'de dünyada en çok konuşulan dil olabilir.', edges:[{target:'es_test_son',matchType:'always',label:''}]},
    {id:'es_test_son', type:'message', position:{x:3300,y:2020},
     content:'🇪🇸 <b>¡Fantástico! Tamamlandı!</b>\n\nXP: <b>{{xp}}</b> | Level: <b>{{level}}</b>\n\n🌎 İspanyolca bilerek 20 ülkeye merhaba diyebilirsin!',
     inlineButtons:[
       [{text:'🔁 Tekrar',callback:'es_test'},{text:'🎵 Müzikle Öğren',callback:'es_muzik'}],
       [{text:'🏠 Ana Menü',callback:'ana_menu'}]
     ],
     edges:[
       {target:'es_t1',matchType:'exact',value:'es_test',label:''},
       {target:'es_muzik_msg',matchType:'exact',value:'es_muzik',label:''},
       {target:'s1',matchType:'always',label:''}
     ]},
    {id:'es_muzik_msg', type:'message', position:{x:3550,y:480},
     content:'🎵 <b>İspanyolca Müzikle Öğrenmek</b>\n\nMüzik dil öğrenmenin bilimsel olarak kanıtlanmış en etkili yollarından biri! Ritim hafızayı güçlendirir.\n\n🎸 <b>Başlangıç için Önerilen Şarkılar:</b>\n\n🎵 Shakira — "Waka Waka" (yavaş, net telaffuz)\n🎵 Enrique Iglesias — "Bailando" (dans kelimesi öğrenirsin)\n🎵 Bad Bunny — Reggaeton (modern slang)\n🎵 La Bamba — geleneksel, herkese tanıdık\n🎵 Despacito — Luis Fonsi (dikkatli seç, romantik 😄)\n\n📱 <b>Öneri:</b>\nSpotify\'da "Learn Spanish with Music" playlistleri var!\nSözleri açarak dinle, tekrar et.\n\n💡 <b>Yöntem:</b>\n1. Sözleri bul\n2. Dinlerken takip et\n3. Bilmediğin kelimeleri not al\n4. Çevir ve tekrar dinle',
     inlineButtons:[
       [{text:'🎵 Spotify\'a Git',url:'https://www.spotify.com'},{text:'🧪 Test Çöz',callback:'es_test'}],
       [{text:'🏠 Menü',callback:'ana_menu'}]
     ],
     edges:[
       {target:'es_t1',matchType:'exact',value:'es_test',label:''},
       {target:'s1',matchType:'always',label:''}
     ]},
    {id:'es_cumle_msg', type:'message', position:{x:3700,y:480},
     content:'💬 <b>Temel İspanyolca — Günlük Hayat</b>\n\n<b>Selamlaşma:</b>\n• ¡Hola! = Merhaba!\n• Buenos días = Günaydın\n• Buenas tardes = İyi öğleden sonralar\n• Buenas noches = İyi geceler\n• ¡Hasta luego! = Görüşürüz!\n• ¡Adiós! = Hoşça kal!\n\n<b>Kibarlık:</b>\n• Gracias = Teşekkürler\n• De nada = Rica ederim\n• Por favor = Lütfen\n• Perdón / Lo siento = Özür dilerim\n\n<b>Acil Durumlar:</b>\n• ¡Ayuda! = Yardım!\n• ¡Llame a la policía! = Polisi arayın!\n• No entiendo = Anlamıyorum\n• ¿Habla inglés? = İngilizce biliyor musunuz?\n\n<b>Alışveriş:</b>\n• ¿Cuánto cuesta? = Ne kadar?\n• Muy caro = Çok pahalı\n• La cuenta = Hesap',
     inlineButtons:[
       [{text:'🧪 Test',callback:'es_test'},{text:'🏠 Menü',callback:'ana_menu'}]
     ],
     edges:[
       {target:'es_t1',matchType:'exact',value:'es_test',label:''},
       {target:'s1',matchType:'always',label:''}
     ]},
    {id:'es_kultur_msg', type:'message', position:{x:3850,y:480},
     content:'🌮 <b>Latin Amerika ve İspanya Kültürü</b>\n\n🎭 <b>Flamenco:</b>\nAndalusya\'dan çıkan bu dans formu UNESCO Kültürel Miras listesinde. Sadece dans değil, bir yaşam felsefesi!\n\n🥩 <b>Asado:</b>\nArjantin ve Uruguay\'a özgü barbekü geleneği. Bir sosyal etkinlik — saatlerce sürer, aile ve arkadaşlarla geçirilir.\n\n☕ <b>Yerba Mate:</b>\nGüney Amerika\'da çay gibi içilen, kafein içeren geleneksel içecek. Paylaşılarak içilmesi sosyal bir ritüel.\n\n💃 <b>Karneval / Día de los Muertos:</b>\nBrezilya Karnavalı ve Meksika\'nın Ölüler Günü — renk, müzik ve kutlamanın zirveleri!\n\n⚽ <b>Futbol Dini:</b>\nArjantin, Brezilya, Uruguay Dünya Kupası\'nı en çok kazanan ülkeler arasında. Futbol burada bir din!\n\n🏛️ <b>Maya ve Aztek Mirası:</b>\nMeksika ve Guatemala\'daki piramitler Mısır piramitlerinden daha büyük!',
     inlineButtons:[
       [{text:'🧪 Test Çöz',callback:'es_test'},{text:'🏠 Menü',callback:'ana_menu'}]
     ],
     edges:[
       {target:'es_t1',matchType:'exact',value:'es_test',label:''},
       {target:'s1',matchType:'always',label:''}
     ]},

    // ══════════════════════════════════════════
    // LEADERBOARD & STATS
    // ══════════════════════════════════════════
    {
      id:'lb_node', type:'leaderboard', position:{x:600,y:1800},
      leaderboardField:'xp', leaderboardLimit:10,
      title:'🏆 Dil Öğrenme Şampiyonları — Top 10',
      emptyMessage:'Henüz sıralama oluşmadı. İlk sen ol! ⭐',
      edges:[{target:'s1',matchType:'always',label:''}]
    },
  ]
};

const COLORS = {
  start:          { bg:'#0d2318', border:'#22c55e',  label:'#4ade80' },
  message:        { bg:'#0d1a2e', border:'#3b82f6',  label:'#60a5fa' },
  question:       { bg:'#1a0d2e', border:'#8b5cf6',  label:'#a78bfa' },
  choice:         { bg:'#2e1a0d', border:'#f59e0b',  label:'#fbbf24' },
  photo:          { bg:'#0d2e2e', border:'#06b6d4',  label:'#22d3ee' },
  video:          { bg:'#2e0d2e', border:'#ec4899',  label:'#f472b6' },
  location:       { bg:'#2e2e0d', border:'#f97316',  label:'#fb923c' },
  file:           { bg:'#0d0d2e', border:'#6366f1',  label:'#818cf8' },
  cv_text:        { bg:'#0d2e0d', border:'#10b981',  label:'#34d399' },
  ai:             { bg:'#1a0d2e', border:'#e879f9',  label:'#f0abfc' },
  command:        { bg:'#2e1a0d', border:'#84cc16',  label:'#a3e635' },
  contact:        { bg:'#0d1a2e', border:'#38bdf8',  label:'#7dd3fc' },
  delay:          { bg:'#2e2e2e', border:'#94a3b8',  label:'#cbd5e1' },
  api_call:       { bg:'#0d2e1a', border:'#2dd4bf',  label:'#5eead4' },
  save:           { bg:'#2e1a0d', border:'#fb923c',  label:'#fdba74' },
  end:            { bg:'#2e0d0d', border:'#ef4444',  label:'#f87171' },
  // Profil node'ları
  add_xp:         { bg:'#1a2e0d', border:'#fbbf24',  label:'#fde68a' },
  add_points:     { bg:'#1a2e0d', border:'#f59e0b',  label:'#fcd34d' },
  profile_set:    { bg:'#0d1a2e', border:'#818cf8',  label:'#a5b4fc' },
  profile_get:    { bg:'#0d1a2e', border:'#60a5fa',  label:'#93c5fd' },
  check_level:    { bg:'#1a0d2e', border:'#a78bfa',  label:'#c4b5fd' },
  leaderboard:    { bg:'#2e1a0d', border:'#fbbf24',  label:'#fde68a' },
  achievement:    { bg:'#2e2e0d', border:'#f59e0b',  label:'#fcd34d' },
  correct_answer: { bg:'#0d2e0d', border:'#4ade80',  label:'#86efac' },
  wrong_answer:   { bg:'#2e0d0d', border:'#f87171',  label:'#fca5a5' },
};

const ICONS = {
  start:'🚀', message:'💬', question:'❓', choice:'🔘',
  photo:'📸', video:'🎥', location:'📍', file:'📎',
  cv_text:'📝', ai:'🤖', command:'⌨️', contact:'📱',
  delay:'⏱️', api_call:'🌐', save:'💾', end:'🏁',
  add_xp:'⚡', add_points:'🪙', profile_set:'✏️', profile_get:'📖',
  check_level:'🎯', leaderboard:'🏆', achievement:'🏅',
  correct_answer:'✅', wrong_answer:'❌',
};

const LABELS = {
  start:'Başlangıç', message:'Mesaj', question:'Soru', choice:'Seçenek',
  photo:'Fotoğraf', video:'Video', location:'Konum', file:'Dosya',
  cv_text:'CV Metin', ai:'Yapay Zeka', command:'Komut', contact:'Telefon',
  delay:'Bekleme', api_call:'API Çağrı', save:'Kaydet', end:'Bitiş',
  add_xp:'XP Ekle', add_points:'Puan/Coin', profile_set:'Profil Yaz',
  profile_get:'Profil Oku', check_level:'Level Kontrol', leaderboard:'Sıralama',
  achievement:'Başarı', correct_answer:'Doğru Cevap', wrong_answer:'Yanlış Cevap',
};

const NODE_GROUPS = [
  { label:'📨 Mesaj', types:['start','message','end'] },
  { label:'📥 Veri Al', types:['question','choice','photo','video','location','file','cv_text','contact'] },
  { label:'🧠 Akıllı', types:['ai','api_call','delay'] },
  { label:'👤 Profil', types:['add_xp','add_points','profile_set','profile_get','check_level','leaderboard','achievement'] },
  { label:'🎮 Oyun', types:['correct_answer','wrong_answer'] },
  { label:'⚙️ Sistem', types:['command','save'] },
];

const VARIABLES_HELP = [
  { v:'{{first_name}}', d:'Telegram adı' },
  { v:'{{full_name}}', d:'Tam ad' },
  { v:'{{username}}', d:'@kullanıcıadı' },
  { v:'{{xp}}', d:'Toplam XP' },
  { v:'{{level}}', d:'Mevcut level' },
  { v:'{{points}}', d:'Puan' },
  { v:'{{coins}}', d:'Coin' },
  { v:'{{streak}}', d:'Günlük seri' },
  { v:'{{total_correct}}', d:'Doğru cevap' },
];

function FlowNode({ data, selected }) {
  const c = COLORS[data.type]||COLORS.message;
  return (
    <div style={{ background:c.bg, border:`2px solid ${selected?'#fff':c.border}`, borderRadius:12, padding:'10px 14px', minWidth:170, maxWidth:240, boxShadow:selected?`0 0 0 3px ${c.border}55`:'0 2px 12px rgba(0,0,0,0.5)', cursor:'grab', userSelect:'none' }}>
      <Handle type="target" position={Position.Top} style={{ background:c.border, width:10, height:10, border:'2px solid #0f1a2e' }}/>
      <div style={{ display:'flex', alignItems:'center', gap:7, marginBottom:data.content?5:0 }}>
        <span style={{ fontSize:15 }}>{ICONS[data.type]||'📦'}</span>
        <span style={{ fontSize:11, fontWeight:700, color:c.label, textTransform:'uppercase', letterSpacing:'0.5px' }}>{LABELS[data.type]||data.type}</span>
      </div>
      {data.content && <div style={{ fontSize:12, color:'rgba(255,255,255,0.8)', lineHeight:1.4 }}>{data.content.length>60?data.content.slice(0,60)+'…':data.content}</div>}
      {data.type==='add_xp' && <div style={{ fontSize:12, color:c.label }}>+{data.xpAmount||10} XP</div>}
      {data.type==='add_points' && <div style={{ fontSize:12, color:c.label }}>+{data.pointsAmount||0} puan / +{data.coinsAmount||0} coin</div>}
      {data.type==='api_call' && data.apiUrl && <div style={{ fontSize:11, color:c.label, fontFamily:'monospace' }}>{data.apiMethod||'GET'} {data.apiUrl.substring(0,30)}...</div>}
      {data.type==='profile_set' && data.fieldKey && <div style={{ fontSize:11, color:c.label }}>{data.fieldKey} = {data.fieldValue}</div>}
      {data.type==='profile_get' && data.fieldKey && <div style={{ fontSize:11, color:c.label }}>← {data.fieldKey}</div>}
      {data.type==='delay' && <div style={{ fontSize:12, color:c.label }}>⏱ {data.delaySeconds||3}s</div>}
      {data.type==='command' && data.command && <div style={{ fontSize:12, color:c.label, fontFamily:'monospace' }}>/{data.command}</div>}
      {data.buttons?.length>0 && (
        <div style={{ display:'flex', flexWrap:'wrap', gap:3, marginTop:4 }}>
          {data.buttons.slice(0,3).map((b,i) => <span key={i} style={{ fontSize:10, padding:'2px 6px', borderRadius:8, background:`${c.border}22`, border:`1px solid ${c.border}44`, color:c.label }}>{b}</span>)}
        </div>
      )}
      <Handle type="source" position={Position.Bottom} style={{ background:c.border, width:10, height:10, border:'2px solid #0f1a2e' }}/>
    </div>
  );
}

const nodeTypes = { flowNode: FlowNode };

function EdgeModal({ edge, onSave, onDelete, onClose }) {
  const [matchType, setMatchType] = useState(edge.data?.matchType||'always');
  const [value, setValue] = useState(edge.data?.value||'');
  const [label, setLabel] = useState(edge.data?.label||'');

  const condTypes = [
    { v:'always', l:'🟢 Her zaman' },
    { v:'exact', l:'🎯 Tam eşleşme' },
    { v:'contains', l:'🔍 İçeriyorsa' },
    { v:'regex', l:'⚡ Regex' },
    { v:'profile_xp_gte', l:'⚡ XP ≥' },
    { v:'profile_level_gte', l:'🎯 Level ≥' },
    { v:'profile_field_eq', l:'✏️ Alan = Değer' },
    { v:'number_gte', l:'🔢 Sayı ≥' },
    { v:'number_lte', l:'🔢 Sayı ≤' },
  ];

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.75)', backdropFilter:'blur(4px)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:2000 }} onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div style={{ background:'#111927', border:'1px solid rgba(255,255,255,0.12)', borderRadius:14, padding:28, width:460 }}>
        <div style={{ fontSize:16, fontWeight:600, color:'#e2e8f0', marginBottom:16 }}>🔗 Ok Koşulu</div>
        <div style={{ marginBottom:14 }}>
          <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:6 }}>KOŞUL TİPİ</label>
          <select className="input" value={matchType} onChange={e=>setMatchType(e.target.value)} style={{ fontSize:13 }}>
            {condTypes.map(t => <option key={t.v} value={t.v}>{t.l}</option>)}
          </select>
        </div>
        {matchType!=='always' && (
          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:6 }}>
              {matchType==='profile_field_eq' ? 'ALAN=DEĞER (örn: city=istanbul)' : 'DEĞER'}
            </label>
            <input className="input" value={value} onChange={e=>setValue(e.target.value)}
              placeholder={matchType==='profile_xp_gte'?'100':matchType==='profile_level_gte'?'3':matchType==='profile_field_eq'?'alan=deger':'Değer girin'}
              style={{ fontSize:13 }} autoFocus/>
          </div>
        )}
        <div style={{ marginBottom:20 }}>
          <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:6 }}>ETİKET</label>
          <input className="input" value={label} onChange={e=>setLabel(e.target.value)} placeholder="Görünen etiket" style={{ fontSize:13 }}/>
        </div>
        <div style={{ display:'flex', gap:10 }}>
          <button className="btn btn-danger btn-sm" onClick={onDelete} style={{ flex:1, justifyContent:'center' }}>🗑 Sil</button>
          <button className="btn btn-ghost btn-sm" onClick={onClose} style={{ flex:1, justifyContent:'center' }}>İptal</button>
          <button className="btn btn-primary" onClick={()=>onSave({matchType,value,label:label||value||'devam'})} style={{ flex:2, justifyContent:'center' }}>✓ Kaydet</button>
        </div>
      </div>
    </div>
  );
}

function NodePanel({ node, onSave, onDelete, onClose }) {
  const [data, setData] = useState({...node.data});
  const [tab, setTab] = useState('content');
  const fileInputRef = useRef();

  function upd(k,v) { setData(d=>({...d,[k]:v})); }
  function addBtn() { upd('buttons',[...(data.buttons||[]),'Seçenek']); }
  function updBtn(i,v) { const b=[...(data.buttons||[])]; b[i]=v; upd('buttons',b); }
  function rmBtn(i) { upd('buttons',(data.buttons||[]).filter((_,idx)=>idx!==i)); }

  async function pickMedia(e) {
    const file = e.target.files[0]; if (!file) return;
    const reader = new FileReader();
    reader.onload = () => { upd('mediaBlob',reader.result); upd('mediaType',file.type); upd('mediaFile',file); upd('mediaName',file.name); };
    reader.readAsDataURL(file);
  }

  async function handleSave() {
    let d = {...data};
    if (d.mediaFile) {
      const form = new FormData(); form.append('file', d.mediaFile);
      try {
        const res = await fetch(`${BASE_URL}/api/flows/upload-media`, { method:'POST', headers:{ Authorization:`Bearer ${localStorage.getItem('token')}` }, body:form });
        const json = await res.json();
        if (json.filename) { d.mediaPath=json.filename; d.mediaType=d.mediaFile.type; }
      } catch(e) {}
    }
    const {mediaFile,mediaBlob,mediaName,...clean} = d;
    onSave({...node, data:clean});
  }

  const c = COLORS[data.type]||COLORS.message;

  // Tab'ları node tipine göre belirle
  const getTabs = () => {
    const base = [{k:'content',l:'İçerik'}];
    if (!['add_xp','add_points','profile_set','profile_get','check_level','achievement','correct_answer','wrong_answer','api_call','leaderboard'].includes(data.type)) {
      base.push({k:'media',l:'Medya'});
      base.push({k:'buttons',l:'Klavye'});
      base.push({k:'inline',l:'Inline Btn'});
    }
    if (data.type==='ai') base.push({k:'ai',l:'YZ Ayarı'});
    if (data.type==='delay') base.push({k:'delay',l:'Süre'});
    if (data.type==='command') base.push({k:'cmd',l:'Komut'});
    if (data.type==='api_call') base.push({k:'api',l:'API Ayarı'});
    if (['add_xp','correct_answer'].includes(data.type)) base.push({k:'xp',l:'XP Ayarı'});
    if (data.type==='add_points') base.push({k:'points',l:'Puan Ayarı'});
    if (['profile_set','profile_get'].includes(data.type)) base.push({k:'profile_field',l:'Alan Ayarı'});
    if (data.type==='leaderboard') base.push({k:'lb',l:'Sıralama Ayarı'});
    if (data.type==='achievement') base.push({k:'ach',l:'Başarı Ayarı'});
    return base;
  };

  const tabs = getTabs();

  return (
    <div style={{ position:'fixed', right:0, top:0, bottom:0, width:370, background:'#111927', borderLeft:'1px solid rgba(255,255,255,0.08)', display:'flex', flexDirection:'column', zIndex:1000, boxShadow:'-4px 0 24px rgba(0,0,0,0.4)' }}>
      <div style={{ padding:'12px 16px', borderBottom:'1px solid rgba(255,255,255,0.07)', display:'flex', alignItems:'center', justifyContent:'space-between', background:`${c.border}12` }}>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <span style={{ fontSize:18 }}>{ICONS[data.type]||'📦'}</span>
          <span style={{ fontWeight:700, fontSize:14, color:c.label }}>{LABELS[data.type]||data.type}</span>
        </div>
        <button onClick={onClose} style={{ background:'none', border:'none', color:'#64748b', cursor:'pointer', fontSize:18 }}>✕</button>
      </div>

      <div style={{ padding:'8px 14px', borderBottom:'1px solid rgba(255,255,255,0.06)' }}>
        <select className="input" value={data.type} onChange={e=>setData(d=>({...d,type:e.target.value,buttons:[],inlineButtons:[]}))} style={{ fontSize:13 }}>
          {Object.entries(LABELS).map(([v,l])=><option key={v} value={v}>{ICONS[v]||'📦'} {l}</option>)}
        </select>
      </div>

      <div style={{ display:'flex', borderBottom:'1px solid rgba(255,255,255,0.07)', overflowX:'auto' }}>
        {tabs.map(t=>(
          <button key={t.k} onClick={()=>setTab(t.k)} style={{ flexShrink:0, padding:'7px 10px', fontSize:11, fontWeight:tab===t.k?600:400, color:tab===t.k?'var(--text)':'var(--text3)', background:'none', border:'none', cursor:'pointer', borderBottom:tab===t.k?'2px solid var(--c4)':'2px solid transparent', whiteSpace:'nowrap' }}>{t.l}</button>
        ))}
      </div>

      <div style={{ flex:1, overflowY:'auto', padding:'14px 16px' }}>

        {/* Değişken yardımı */}
        {tab==='content' && (
          <div style={{ marginBottom:12, background:'rgba(59,130,246,0.06)', border:'1px solid rgba(59,130,246,0.15)', borderRadius:8, padding:'8px 12px' }}>
            <div style={{ fontSize:11, color:'#60a5fa', marginBottom:6, fontWeight:600 }}>📌 KULLANILABILIR DEĞİŞKENLER</div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:4 }}>
              {VARIABLES_HELP.map(v => (
                <span key={v.v} onClick={()=>upd('content',(data.content||'')+v.v)}
                  style={{ fontSize:11, padding:'2px 6px', borderRadius:6, background:'rgba(59,130,246,0.15)', color:'#93c5fd', cursor:'pointer', border:'1px solid rgba(59,130,246,0.2)' }}
                  title={v.d}>{v.v}</span>
              ))}
            </div>
          </div>
        )}

        {tab==='content' && (
          <>
            {!['end','delay','api_call','profile_set','add_xp','add_points','achievement'].includes(data.type) && (
              <div style={{ marginBottom:12 }}>
                <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>MESAJ / SORU</label>
                <textarea className="input" value={data.content||''} onChange={e=>upd('content',e.target.value)}
                  placeholder="{{first_name}} yazan değişkenleri kullanabilirsin"
                  style={{ minHeight:90, fontSize:13 }}/>
              </div>
            )}
            {!['message','start','end','delay','command','api_call','add_xp','add_points','profile_set','check_level','leaderboard','achievement','correct_answer','wrong_answer','profile_get'].includes(data.type) && (
              <div style={{ marginBottom:12 }}>
                <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>ALAN ADI (veri kaydetmek için)</label>
                <input className="input" value={data.key||''} onChange={e=>upd('key',e.target.value)} placeholder="orn: sehir, pozisyon" style={{ fontSize:13 }}/>
              </div>
            )}
          </>
        )}

        {tab==='media' && (
          <>
            {(data.mediaBlob||data.mediaPath) ? (
              <div style={{ position:'relative', marginBottom:12 }}>
                {(data.mediaType||'').startsWith('image/') ?
                  <img src={data.mediaBlob||`${BASE_URL}/uploads/${data.mediaPath}`} alt="" style={{ width:'100%', maxHeight:120, objectFit:'cover', borderRadius:8 }}/> :
                  <div style={{ padding:8, background:'rgba(255,255,255,0.05)', borderRadius:6, fontSize:12, color:'#94a3b8' }}>📎 {data.mediaName||data.mediaPath}</div>
                }
                <button onClick={()=>setData(d=>({...d,mediaPath:'',mediaType:'',mediaBlob:'',mediaFile:null,mediaName:''}))}
                  style={{ position:'absolute', top:4, right:4, background:'rgba(0,0,0,0.7)', border:'none', color:'white', borderRadius:'50%', width:22, height:22, cursor:'pointer', fontSize:12 }}>✕</button>
              </div>
            ) : null}
            <input ref={fileInputRef} type="file" accept="image/*,video/*" style={{ display:'none' }} onChange={pickMedia}/>
            <button className="btn btn-ghost btn-sm" onClick={()=>fileInputRef.current.click()} style={{ width:'100%', justifyContent:'center', marginBottom:10 }}>📎 Resim / GIF / Video Ekle</button>
            {data.mediaPath && (
              <div style={{ marginBottom:12 }}>
                <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>AÇIKLAMA</label>
                <input className="input" value={data.mediaCaption||''} onChange={e=>upd('mediaCaption',e.target.value)} style={{ fontSize:13 }}/>
              </div>
            )}
          </>
        )}

        {tab==='buttons' && (
          <div>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>DİZİLİM</label>
              <select className="input" value={data.buttonLayout||'vertical'} onChange={e=>upd('buttonLayout',e.target.value)} style={{ fontSize:12 }}>
                <option value="vertical">Dikey (alt alta)</option>
                <option value="horizontal">Yatay (yan yana)</option>
              </select>
            </div>
            {(data.buttons||[]).map((b,i)=>(
              <div key={i} style={{ display:'flex', gap:6, marginBottom:6 }}>
                <input className="input" value={b} onChange={e=>updBtn(i,e.target.value)} style={{ flex:1, fontSize:13 }}/>
                <button className="btn btn-danger btn-sm" onClick={()=>rmBtn(i)}>✕</button>
              </div>
            ))}
            <button className="btn btn-ghost btn-sm" onClick={addBtn}>+ Buton Ekle</button>
          </div>
        )}

        {tab==='inline' && (
          <InlineButtonBuilder value={data.inlineButtons||[]} onChange={v=>upd('inlineButtons',v)}/>
        )}

        {tab==='ai' && (
          <>
            <div style={{ background:'rgba(232,121,249,0.08)', border:'1px solid rgba(232,121,249,0.2)', borderRadius:8, padding:10, marginBottom:12, fontSize:12, color:'#f0abfc' }}>
              🤖 Hugging Face API — Bot ayarlarından API key gerekli
            </div>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>SİSTEM PROMPTU</label>
              <textarea className="input" value={data.aiPrompt||''} onChange={e=>upd('aiPrompt',e.target.value)}
                placeholder="Sen yardımcı bir asistansın. Türkçe cevap ver..." style={{ minHeight:80, fontSize:12 }}/>
            </div>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>HATA MESAJI</label>
              <input className="input" value={data.aiErrorMsg||''} onChange={e=>upd('aiErrorMsg',e.target.value)} placeholder="Şu an cevap veremiyorum..." style={{ fontSize:12 }}/>
            </div>
          </>
        )}

        {tab==='delay' && (
          <div style={{ marginBottom:12 }}>
            <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>BEKLEME SÜRESİ (saniye, maks 300)</label>
            <input className="input" type="number" min="1" max="300" value={data.delaySeconds||3} onChange={e=>upd('delaySeconds',parseInt(e.target.value))} style={{ fontSize:13 }}/>
          </div>
        )}

        {tab==='cmd' && (
          <div style={{ marginBottom:12 }}>
            <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>KOMUT ADI (/ olmadan)</label>
            <input className="input" value={data.command||''} onChange={e=>upd('command',e.target.value)} placeholder="yardim, menu, profil" style={{ fontSize:13 }}/>
            <div style={{ fontSize:11, color:'#334155', marginTop:3 }}>
              Not: /profil ve /sira komutları otomatik olarak yerleşik gelir.
            </div>
          </div>
        )}

        {tab==='api' && (
          <>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>API URL</label>
              <input className="input" value={data.apiUrl||''} onChange={e=>upd('apiUrl',e.target.value)}
                placeholder="https://api.openweathermap.org/data/2.5/weather?q={{sehir}}&appid=KEY" style={{ fontSize:12 }}/>
              <div style={{ fontSize:11, color:'#334155', marginTop:3 }}>URL'de {'{{degisken}}'} kullanabilirsin</div>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:10 }}>
              <div>
                <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>METHOD</label>
                <select className="input" value={data.apiMethod||'GET'} onChange={e=>upd('apiMethod',e.target.value)} style={{ fontSize:12 }}>
                  <option value="GET">GET</option>
                  <option value="POST">POST</option>
                  <option value="PUT">PUT</option>
                  <option value="DELETE">DELETE</option>
                </select>
              </div>
              <div>
                <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>TIMEOUT (saniye)</label>
                <input type="number" className="input" value={data.apiTimeout||10} onChange={e=>upd('apiTimeout',e.target.value)} style={{ fontSize:12 }}/>
              </div>
            </div>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>HEADERS (JSON formatı)</label>
              <textarea className="input" value={data.apiHeaders||''} onChange={e=>upd('apiHeaders',e.target.value)}
                placeholder={'{"Authorization": "Bearer TOKEN", "Content-Type": "application/json"}'}
                style={{ minHeight:60, fontSize:11, fontFamily:'monospace' }}/>
            </div>
            {data.apiMethod !== 'GET' && (
              <div style={{ marginBottom:10 }}>
                <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>REQUEST BODY (JSON)</label>
                <textarea className="input" value={data.apiBody||''} onChange={e=>upd('apiBody',e.target.value)}
                  placeholder={'{"query": "{{soru}}", "user_id": "{{telegram_id}}"}'}
                  style={{ minHeight:60, fontSize:11, fontFamily:'monospace' }}/>
              </div>
            )}
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>CEVAPTAN ALAN AL (path)</label>
              <input className="input" value={data.apiResponseKey||''} onChange={e=>upd('apiResponseKey',e.target.value)}
                placeholder="main.temp veya items[0].name" style={{ fontSize:12 }}/>
              <div style={{ fontSize:11, color:'#334155', marginTop:3 }}>Noktalı path ile iç içe alanlara ulaş</div>
            </div>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>KAYIT ADI (profil alanına kaydet)</label>
              <input className="input" value={data.apiSaveAs||''} onChange={e=>upd('apiSaveAs',e.target.value)}
                placeholder="hava_durumu veya sonuc" style={{ fontSize:12 }}/>
              <div style={{ fontSize:11, color:'#334155', marginTop:3 }}>Kaydedilirse {'{{apiSaveAs}}'} ile mesajlarda kullanabilirsin</div>
            </div>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>BAŞARI MESAJI</label>
              <textarea className="input" value={data.content||''} onChange={e=>upd('content',e.target.value)}
                placeholder="Sonuç: {{hava_durumu}}°C ☀️" style={{ minHeight:60, fontSize:13 }}/>
            </div>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>HATA MESAJI</label>
              <input className="input" value={data.apiErrorMessage||''} onChange={e=>upd('apiErrorMessage',e.target.value)}
                placeholder="Bilgi alınamadı, tekrar deneyin." style={{ fontSize:12 }}/>
            </div>
          </>
        )}

        {tab==='xp' && (
          <>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>VERİLECEK XP MİKTARI</label>
              <input type="number" className="input" value={data.xpAmount||10} onChange={e=>upd('xpAmount',parseInt(e.target.value))} style={{ fontSize:13 }}/>
            </div>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>LEVEL ATLAMA MESAJI</label>
              <textarea className="input" value={data.levelUpMessage||''} onChange={e=>upd('levelUpMessage',e.target.value)}
                placeholder="🎉 Tebrikler {{first_name}}! Yeni seviyeye ulaştın!" style={{ minHeight:60, fontSize:12 }}/>
            </div>
            <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13, marginBottom:10 }}>
              <label className="toggle"><input type="checkbox" checked={!!data.showXPGain} onChange={e=>upd('showXPGain',e.target.checked)}/><span className="toggle-slider"/></label>
              XP kazanıldığında göster (+10 XP kazandın!)
            </label>
            {data.type==='correct_answer' && (
              <div style={{ marginBottom:10 }}>
                <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>DOĞRU CEVAP MESAJI</label>
                <textarea className="input" value={data.content||''} onChange={e=>upd('content',e.target.value)}
                  placeholder="✅ Doğru! +{{xpAmount}} XP kazandın! Toplam: {{xp}} XP" style={{ minHeight:60, fontSize:13 }}/>
              </div>
            )}
          </>
        )}

        {tab==='points' && (
          <>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
              <div>
                <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>PUAN MİKTARI</label>
                <input type="number" className="input" value={data.pointsAmount||0} onChange={e=>upd('pointsAmount',parseInt(e.target.value))} style={{ fontSize:13 }}/>
              </div>
              <div>
                <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>COİN MİKTARI</label>
                <input type="number" className="input" value={data.coinsAmount||0} onChange={e=>upd('coinsAmount',parseInt(e.target.value))} style={{ fontSize:13 }}/>
              </div>
            </div>
            <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13 }}>
              <label className="toggle"><input type="checkbox" checked={!!data.showGain} onChange={e=>upd('showGain',e.target.checked)}/><span className="toggle-slider"/></label>
              Kazanımı kullanıcıya göster
            </label>
          </>
        )}

        {tab==='profile_field' && (
          <>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>ALAN ADI</label>
              <input className="input" value={data.fieldKey||''} onChange={e=>upd('fieldKey',e.target.value)}
                placeholder="sehir, favori_renk, seviye_turu" style={{ fontSize:13 }}/>
            </div>
            {data.type==='profile_set' && (
              <>
                <div style={{ marginBottom:10 }}>
                  <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>DEĞER</label>
                  <input className="input" value={data.fieldValue||''} onChange={e=>upd('fieldValue',e.target.value)}
                    placeholder="Sabit değer veya flow değişkeni adı" style={{ fontSize:13 }}/>
                </div>
                <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13 }}>
                  <label className="toggle"><input type="checkbox" checked={!!data.useFlowData} onChange={e=>upd('useFlowData',e.target.checked)}/><span className="toggle-slider"/></label>
                  Flow'daki değişkenden al (field value = field key'den al)
                </label>
              </>
            )}
            {data.type==='profile_get' && (
              <>
                <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13, marginTop:10 }}>
                  <label className="toggle"><input type="checkbox" checked={!!data.showValue} onChange={e=>upd('showValue',e.target.checked)}/><span className="toggle-slider"/></label>
                  Değeri kullanıcıya göster
                </label>
                {data.showValue && (
                  <div style={{ marginTop:10 }}>
                    <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>MESAJ ŞABLONU</label>
                    <textarea className="input" value={data.content||''} onChange={e=>upd('content',e.target.value)}
                      placeholder={`Senin şehrin: {{${data.fieldKey||'alan'}}}`} style={{ minHeight:50, fontSize:12 }}/>
                  </div>
                )}
              </>
            )}
          </>
        )}

        {tab==='lb' && (
          <>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>SIRALA</label>
              <select className="input" value={data.leaderboardField||'xp'} onChange={e=>upd('leaderboardField',e.target.value)} style={{ fontSize:13 }}>
                <option value="xp">XP</option>
                <option value="level">Level</option>
                <option value="points">Puan</option>
                <option value="coins">Coin</option>
                <option value="streak">Günlük Seri</option>
                <option value="total_correct">Doğru Cevap</option>
                <option value="games_won">Galibiyet</option>
              </select>
            </div>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>KAÇ KİŞİ GÖSTERİLSİN</label>
              <input type="number" className="input" value={data.leaderboardLimit||10} onChange={e=>upd('leaderboardLimit',parseInt(e.target.value))} style={{ fontSize:13 }} min="3" max="20"/>
            </div>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>BAŞLIK</label>
              <input className="input" value={data.title||''} onChange={e=>upd('title',e.target.value)} placeholder="🏆 En İyi Oyuncular" style={{ fontSize:13 }}/>
            </div>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>BOŞ MESAJI</label>
              <input className="input" value={data.emptyMessage||''} onChange={e=>upd('emptyMessage',e.target.value)} placeholder="Henüz sıralama yok." style={{ fontSize:13 }}/>
            </div>
          </>
        )}

        {tab==='ach' && (
          <>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>BAŞARI ANAHTARI (benzersiz)</label>
              <input className="input" value={data.achievementKey||''} onChange={e=>upd('achievementKey',e.target.value)}
                placeholder="ilk_dogru_cevap, uzman_seviye" style={{ fontSize:13 }}/>
            </div>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>BAŞARI ADI</label>
              <input className="input" value={data.achievementName||''} onChange={e=>upd('achievementName',e.target.value)}
                placeholder="İlk Doğru Cevap 🎯" style={{ fontSize:13 }}/>
            </div>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>KAZANILDIĞINDA MESAJ</label>
              <textarea className="input" value={data.content||''} onChange={e=>upd('content',e.target.value)}
                placeholder="🏅 Tebrikler {{first_name}}! 'İlk Doğru Cevap' rozetini kazandın!" style={{ minHeight:60, fontSize:12 }}/>
            </div>
            <div style={{ marginBottom:10 }}>
              <label style={{ fontSize:11, color:'#6899cc', display:'block', marginBottom:5 }}>ZATEN KAZANILDIYSA</label>
              <input className="input" value={data.alreadyEarnedMessage||''} onChange={e=>upd('alreadyEarnedMessage',e.target.value)}
                placeholder="Bu rozeti zaten kazandın!" style={{ fontSize:12 }}/>
            </div>
          </>
        )}

      </div>

      <div style={{ padding:'12px 16px', borderTop:'1px solid rgba(255,255,255,0.07)', display:'flex', gap:8 }}>
        <button className="btn btn-danger btn-sm" onClick={()=>onDelete(node.id)} style={{ flex:1, justifyContent:'center' }}>Sil</button>
        <button className="btn btn-primary" onClick={handleSave} style={{ flex:2, justifyContent:'center' }}>💾 Kaydet</button>
      </div>
    </div>
  );
}

let _id = 1;
function uid() { return `n_${Date.now()}_${_id++}`; }

function makeEdge(source, target, data={}) {
  const isCond = data.matchType && data.matchType!=='always';
  return {
    id:`e_${source}_${target}_${Date.now()}`,
    source, target, data,
    label: data.label||'',
    labelStyle:{fill:isCond?'#e879f9':'#60a5fa',fontSize:11,fontWeight:600},
    labelBgStyle:{fill:'#0f1728',fillOpacity:0.9,rx:4},
    labelBgPadding:[4,6],
    markerEnd:{type:MarkerType.ArrowClosed,color:isCond?'#e879f9':'#3b82f6'},
    style:{stroke:isCond?'#e879f9':'#3b82f6',strokeWidth:2,strokeDasharray:isCond?'6,3':'0'},
    animated:!isCond,
  };
}

function stepsToRF(steps) {
  const nodes = (steps||[]).map(s=>({id:s.id,type:'flowNode',position:s.position||{x:200,y:100},data:s}));
  const edges = [];
  (steps||[]).forEach(s=>{
    (s.edges||[]).forEach(e=>{
      edges.push(makeEdge(s.id,e.target,{matchType:e.matchType||'always',value:e.value||'',label:e.label||''}));
    });
  });
  return {nodes,edges};
}

function rfToSteps(rfNodes, rfEdges) {
  return rfNodes.map(n=>{
    const outEdges = rfEdges.filter(e=>e.source===n.id).map(e=>({
      target:e.target, matchType:e.data?.matchType||'always', value:e.data?.value||'', label:e.data?.label||'',
    }));
    return {...n.data, id:n.id, position:n.position, edges:outEdges};
  });
}

function FlowEditorInner({ bot, onBack }) {
  const [flows, setFlows] = useState([]);
  const [selFlow, setSelFlow] = useState(null);
  const [flowName, setFlowName] = useState('');
  const [endMsg, setEndMsg] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [saveAsApp, setSaveAsApp] = useState(false);
  const [flowType, setFlowType] = useState('chat');
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [editNode, setEditNode] = useState(null);
  const [editEdge, setEditEdge] = useState(null);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState('');
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [showGeoModal, setShowGeoModal] = useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [allBots, setAllBots] = useState([]);
  const [copyTargetBot, setCopyTargetBot] = useState('');
  const [copying, setCopying] = useState(false);
  const [geoRouting, setGeoRouting] = useState({ enabled: false, rules: [] });
  const {fitView} = useReactFlow();
  const rfInstance = useRef(null);
  const history = useRef([]);
  const future = useRef([]);

  function snapshot() {
    history.current.push({nodes:JSON.parse(JSON.stringify(nodes)),edges:JSON.parse(JSON.stringify(edges))});
    future.current=[];
    if (history.current.length>50) history.current.shift();
  }

  useEffect(()=>{
    function onKey(e) {
      if ((e.ctrlKey||e.metaKey)&&e.key==='z'&&!e.shiftKey) {
        e.preventDefault(); const prev=history.current.pop(); if (!prev) return;
        future.current.push({nodes:JSON.parse(JSON.stringify(nodes)),edges:JSON.parse(JSON.stringify(edges))});
        setNodes(prev.nodes); setEdges(prev.edges);
      }
      if ((e.ctrlKey||e.metaKey)&&(e.key==='y'||(e.key==='z'&&e.shiftKey))) {
        e.preventDefault(); const next=future.current.pop(); if (!next) return;
        history.current.push({nodes:JSON.parse(JSON.stringify(nodes)),edges:JSON.parse(JSON.stringify(edges))});
        setNodes(next.nodes); setEdges(next.edges);
      }
    }
    window.addEventListener('keydown',onKey);
    return ()=>window.removeEventListener('keydown',onKey);
  },[nodes,edges]);

  async function loadFlows() {
    try {
      const [flowRes, botRes] = await Promise.all([
        api.get(`/flows/${bot.id}`),
        api.get('/bots'),
      ]);
      setFlows(flowRes.data);
      setAllBots(botRes.data.filter(b => b.id !== bot.id));
      if (flowRes.data.length>0 && !selFlow) selectFlow(flowRes.data[0]);
    } catch(e) {}
  }
  useEffect(()=>{loadFlows();},[]);

  function selectFlow(flow) {
    setSelFlow(flow); setFlowName(flow.name); setEndMsg(flow.end_message||'');
    setIsActive(flow.is_active); setSaveAsApp(flow.save_as_application!==false); setFlowType(flow.flow_type||'chat');
    setGeoRouting(flow.geo_routing || { enabled: false, rules: [] });
    const {nodes:n,edges:e}=stepsToRF(flow.steps||[]);
    setNodes(n); setEdges(e); setEditNode(null); history.current=[];
    setTimeout(()=>fitView({padding:0.15}),100);
  }

  const onConnect = useCallback((params)=>{
    snapshot();
    const newEdge=makeEdge(params.source,params.target,{matchType:'always',value:'',label:''});
    setEdges(eds=>addEdge(newEdge,eds));
    setEditEdge(newEdge);
  },[nodes,edges]);

  function onEdgeDblClick(_,edge) { setEditEdge(edge); }
  function saveEdgeCondition(condData) { snapshot(); setEdges(eds=>eds.map(e=>e.id!==editEdge.id?e:makeEdge(e.source,e.target,condData))); setEditEdge(null); }
  function deleteEdge() { snapshot(); setEdges(eds=>eds.filter(e=>e.id!==editEdge.id)); setEditEdge(null); }

  function addNode(type) {
    snapshot();
    const id=uid();
    const pos=rfInstance.current?rfInstance.current.project({x:window.innerWidth/2-300,y:200}):{x:200+Math.random()*200,y:200+Math.random()*100};
    setNodes(nds=>[...nds,{id,type:'flowNode',position:pos,data:{id,type,content:'',key:'',buttons:[],inlineButtons:[],edges:[]}}]);
  }

  function onNodeClick(_,node) { setEditNode(node); }
  function saveNode(updated) { snapshot(); setNodes(nds=>nds.map(n=>n.id===updated.id?{...n,data:updated.data}:n)); setEditNode(null); }
  function deleteNode(id) { snapshot(); setNodes(nds=>nds.filter(n=>n.id!==id)); setEdges(eds=>eds.filter(e=>e.source!==id&&e.target!==id)); setEditNode(null); }

  async function saveFlow() {
    setSaving(true);
    try {
      const steps=rfToSteps(nodes,edges);
      const geoData = geoRouting.enabled && geoRouting.rules.length > 0 ? geoRouting : null;
      const payload={name:flowName,steps,end_message:endMsg,is_active:isActive,save_as_application:saveAsApp,flow_type:flowType,geo_routing:geoData};
      if (selFlow) { const res=await api.put(`/flows/${selFlow.id}`,payload); setSelFlow(res.data); }
      else { const res=await api.post('/flows',{bot_id:bot.id,...payload}); setSelFlow(res.data); }
      setToast('✅ Kaydedildi!'); loadFlows();
    } catch(e) { setToast('❌ '+(e.response?.data?.error||e.message)); }
    setSaving(false);
    setTimeout(()=>setToast(''),3000);
  }

  async function copyFlow() {
    if (!selFlow || !copyTargetBot) return;
    setCopying(true);
    try {
      const res = await api.post(`/flows/${selFlow.id}/copy`, {
        target_bot_id: parseInt(copyTargetBot),
        new_name: `${flowName} (Kopya)`,
      });
      setToast('✅ ' + res.data.message);
      setShowCopyModal(false);
    } catch(e) { setToast('❌ ' + (e.response?.data?.error || e.message)); }
    setCopying(false);
    setTimeout(()=>setToast(''),4000);
  }

  async function delFlow() {
    if (!selFlow||!window.confirm('Bu flow silinsin mi?')) return;
    await api.delete(`/flows/${selFlow.id}`);
    setSelFlow(null); setNodes([]); setEdges([]); loadFlows();
  }

  function loadTemplate(template) {
    const now = Date.now();
    let counter = 0;
    const idMap = {};
    // Yeni ID'ler ata
    const newSteps = template.steps.map(s => {
      const newId = `n_${now}_${counter++}`;
      idMap[s.id] = newId;
      return { ...s, id: newId };
    });
    // Edge target'larını güncelle
    const finalSteps = newSteps.map(s => ({
      ...s,
      edges: (s.edges || []).map(e => ({ ...e, target: idMap[e.target] || e.target })),
    }));
    const { nodes: n, edges: e } = stepsToRF(finalSteps);
    setNodes(n); setEdges(e);
    setFlowName(template.name);
    setEndMsg(template.endMsg || '');
    setFlowType(template.flowType || 'chat');
    setIsActive(false);
    setSelFlow(null);
    setShowTemplateModal(false);
    history.current = [];
    setTimeout(() => fitView({ padding: 0.1 }), 150);
  }

  function newFlow() {
    setSelFlow(null); setFlowName('Yeni Flow'); setEndMsg(''); setIsActive(true);
    setSaveAsApp(false); setFlowType('chat'); setEditNode(null); history.current=[];
    setNodes([]); setEdges([]);
  }

  return (
    <div style={{height:'calc(100vh - 48px)',display:'flex',flexDirection:'column'}}>
      <div style={{display:'flex',alignItems:'center',gap:8,padding:'8px 0',flexWrap:'wrap'}}>
        <button className="btn btn-ghost btn-sm" onClick={onBack}>← Geri</button>
        <span style={{fontWeight:700,fontSize:14}}>⚙ Flow Editör — {bot.name}</span>
        <select className="input" value={flowType} onChange={e=>setFlowType(e.target.value)} style={{width:120,padding:'5px 8px',fontSize:12}}>
          <option value="chat">💬 Sohbet</option>
          <option value="form">📋 Form</option>
          <option value="game">🎮 Oyun</option>
          <option value="quiz">🧠 Quiz</option>
          <option value="support">🎧 Destek</option>
          <option value="ecommerce">🛍️ E-Ticaret</option>
          <option value="custom">⚙️ Özel</option>
        </select>
        <div style={{marginLeft:'auto',display:'flex',gap:6,alignItems:'center',flexWrap:'wrap'}}>
          <input className="input" value={flowName} onChange={e=>setFlowName(e.target.value)} style={{width:150,padding:'6px 10px',fontSize:13}} placeholder="Flow adı"/>
          <label style={{display:'flex',alignItems:'center',gap:5,fontSize:12,color:'var(--text2)',cursor:'pointer'}}>
            <label className="toggle"><input type="checkbox" checked={isActive} onChange={e=>setIsActive(e.target.checked)}/><span className="toggle-slider"/></label>Aktif
          </label>
          <label style={{display:'flex',alignItems:'center',gap:5,fontSize:12,color:'var(--text3)',cursor:'pointer'}}>
            <label className="toggle"><input type="checkbox" checked={saveAsApp} onChange={e=>setSaveAsApp(e.target.checked)}/><span className="toggle-slider"/></label>Başvuru
          </label>
          <button className="btn btn-primary btn-sm" onClick={saveFlow} disabled={saving}>{saving?'...':'💾 Kaydet'}</button>
          {selFlow&&<button className="btn btn-ghost btn-sm" onClick={()=>setShowGeoModal(true)} title="Ülkeye göre yönlendirme" style={{borderColor:'rgba(251,191,36,0.4)',color:'#fbbf24'}}>🌍 Geo</button>}
          {selFlow&&<button className="btn btn-ghost btn-sm" onClick={()=>{setCopyTargetBot('');setShowCopyModal(true);}} title="Başka bota kopyala" style={{borderColor:'rgba(74,222,128,0.4)',color:'#4ade80'}}>📋 Kopyala</button>}
          {selFlow&&<button className="btn btn-danger btn-sm" onClick={delFlow}>Sil</button>}
          {toast&&<span style={{fontSize:12,color:toast.startsWith('✅')?'#4ade80':'#f87171'}}>{toast}</span>}
        </div>
      </div>

      <div style={{display:'flex',gap:10,flex:1,minHeight:0}}>
        {/* Sol panel */}
        <div style={{width:165,display:'flex',flexDirection:'column',gap:8,flexShrink:0,overflowY:'auto'}}>
          <div className="card" style={{padding:10}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
              <span style={{fontSize:11,fontWeight:600,color:'var(--text2)'}}>Flowlar</span>
              <div style={{display:'flex',gap:3}}>
              <button className="btn btn-primary btn-sm" onClick={newFlow} style={{padding:'2px 7px',fontSize:10}}>+ Yeni</button>
              <button className="btn btn-ghost btn-sm" onClick={()=>setShowTemplateModal(true)} style={{padding:'2px 7px',fontSize:10}} title="Hazır şablon yükle">📋</button>
            </div>
            </div>
            {flows.map(f=>(
              <div key={f.id} onClick={()=>selectFlow(f)} style={{padding:'6px 8px',borderRadius:5,cursor:'pointer',marginBottom:2,background:selFlow?.id===f.id?'rgba(59,130,246,0.15)':'transparent',border:selFlow?.id===f.id?'1px solid rgba(59,130,246,0.4)':'1px solid transparent'}}>
                <div style={{fontSize:11,fontWeight:500,color:'var(--text)'}}>{f.name}</div>
                <div style={{fontSize:10,color:'var(--text3)',display:'flex',alignItems:'center',gap:3,marginTop:1}}>
                  <span style={{width:4,height:4,borderRadius:'50%',background:f.is_active?'#22c55e':'#64748b',display:'inline-block'}}/>
                  {f.steps?.length||0} node
                </div>
              </div>
            ))}
          </div>

          {NODE_GROUPS.map(g=>(
            <div key={g.label} className="card" style={{padding:8}}>
              <div style={{fontSize:10,fontWeight:600,color:'var(--text3)',marginBottom:5}}>{g.label}</div>
              {g.types.map(type=>{
                const c=COLORS[type]||COLORS.message;
                return (
                  <button key={type} onClick={()=>addNode(type)} style={{display:'flex',alignItems:'center',gap:4,width:'100%',background:'transparent',border:`1px solid ${c.border}33`,borderRadius:4,padding:'4px 6px',cursor:'pointer',color:c.label,fontSize:10,marginBottom:2,transition:'all 0.1s'}}
                    onMouseEnter={e=>e.currentTarget.style.background=`${c.border}18`}
                    onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                    <span style={{fontSize:12}}>{ICONS[type]||'📦'}</span> {LABELS[type]||type}
                  </button>
                );
              })}
            </div>
          ))}

          <div className="card" style={{padding:8}}>
            <label style={{fontSize:10,color:'var(--text3)',display:'block',marginBottom:4}}>BİTİŞ MESAJI</label>
            <textarea className="input" value={endMsg} onChange={e=>setEndMsg(e.target.value)} style={{minHeight:40,fontSize:10}} placeholder="{{first_name}} değişkenleri kullanılabilir"/>
          </div>

          <div style={{fontSize:10,color:'var(--text3)',lineHeight:1.6,padding:'3px'}}>
            💡 Ok çiz → koşul<br/>
            🖱 Oka çift tıkla → düzenle<br/>
            ⌨️ Ctrl+Z geri al<br/>
            📌 /profil ve /sira otomatik
          </div>
        </div>

        {/* Canvas */}
        <div style={{flex:1,background:'#080f1a',borderRadius:10,border:'1px solid rgba(255,255,255,0.06)',overflow:'hidden',position:'relative'}}>
          {nodes.length===0&&(
            <div style={{position:'absolute',inset:0,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',color:'var(--text3)',pointerEvents:'none',zIndex:1}}>
              <div style={{fontSize:36,marginBottom:8,opacity:0.15}}>🔀</div>
              <p style={{fontSize:13}}>Sol panelden node ekle</p>
            </div>
          )}
          <ReactFlow
            nodes={nodes} edges={edges}
            onNodesChange={onNodesChange} onEdgesChange={onEdgesChange}
            onConnect={onConnect} onNodeClick={onNodeClick}
            onEdgeDoubleClick={onEdgeDblClick}
            onInit={inst=>{rfInstance.current=inst;}}
            nodeTypes={nodeTypes} fitView deleteKeyCode={null}
            style={{background:'#080f1a'}}>
            <Background color="#1a2540" gap={20} size={1}/>
            <Controls style={{background:'#111927',border:'1px solid rgba(255,255,255,0.08)',borderRadius:8}}/>
            <MiniMap style={{background:'#111927',border:'1px solid rgba(255,255,255,0.08)',borderRadius:8}} nodeColor={n=>COLORS[n.data?.type]?.border||'#3b82f6'} maskColor="rgba(0,0,0,0.6)"/>
            <Panel position="top-right">
              <button className="btn btn-ghost btn-sm" onClick={()=>fitView({padding:0.15})}>⊡</button>
            </Panel>
          </ReactFlow>
        </div>

        {editNode&&<NodePanel node={editNode} onSave={saveNode} onDelete={deleteNode} onClose={()=>setEditNode(null)}/>}
      </div>

      {/* Şablon Modal */}
      {showTemplateModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.8)',backdropFilter:'blur(4px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:3000}} onClick={e=>e.target===e.currentTarget&&setShowTemplateModal(false)}>
          <div style={{background:'#111927',border:'1px solid rgba(255,255,255,0.12)',borderRadius:14,padding:28,width:480,maxHeight:'80vh',overflowY:'auto'}}>
            <div style={{fontSize:17,fontWeight:700,color:'#e2e8f0',marginBottom:6}}>📋 Hazır Bot Şablonları</div>
            <div style={{fontSize:13,color:'#64748b',marginBottom:20}}>Şablon seç, içerikleri düzenle ve kaydet.</div>
            <div style={{display:'flex',flexDirection:'column',gap:10}}>
              {[LANG_TEMPLATE].map((tmpl, i) => (
                <div key={i} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:10,padding:16,cursor:'pointer',transition:'all 0.15s'}}
                  onMouseEnter={e=>e.currentTarget.style.borderColor='#3b82f6'}
                  onMouseLeave={e=>e.currentTarget.style.borderColor='rgba(255,255,255,0.1)'}>
                  <div style={{fontSize:15,fontWeight:700,color:'var(--text)',marginBottom:4}}>{tmpl.name}</div>
                  <div style={{fontSize:12,color:'var(--text3)',marginBottom:12}}>{tmpl.steps?.length} node · {tmpl.flowType}</div>
                  <button className="btn btn-primary btn-sm" onClick={()=>loadTemplate(tmpl)} style={{justifyContent:'center'}}>
                    ✨ Bu Şablonu Yükle
                  </button>
                </div>
              ))}
            </div>
            <div style={{marginTop:16,display:'flex',justifyContent:'flex-end'}}>
              <button className="btn btn-ghost" onClick={()=>setShowTemplateModal(false)}>Kapat</button>
            </div>
          </div>
        </div>
      )}

      {editEdge&&<EdgeModal edge={editEdge} onSave={saveEdgeCondition} onDelete={deleteEdge} onClose={()=>setEditEdge(null)}/>}

      {/* Flow Kopyalama Modal */}
      {showCopyModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.75)',backdropFilter:'blur(4px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:3000}} onClick={e=>e.target===e.currentTarget&&setShowCopyModal(false)}>
          <div style={{background:'#111927',border:'1px solid rgba(255,255,255,0.12)',borderRadius:14,padding:28,width:420}}>
            <div style={{fontSize:16,fontWeight:700,color:'#e2e8f0',marginBottom:6}}>📋 Flow Kopyala</div>
            <div style={{fontSize:13,color:'#64748b',marginBottom:20}}>
              <b style={{color:'#4ade80'}}>{flowName}</b> flow'unu başka bir bota kopyala
            </div>
            <div style={{marginBottom:20}}>
              <label style={{fontSize:11,color:'#6899cc',display:'block',marginBottom:8}}>HEDEF BOT</label>
              {allBots.length === 0 ? (
                <div style={{fontSize:13,color:'#f87171'}}>Başka bot bulunamadı. Önce yeni bir bot ekleyin.</div>
              ) : (
                <div style={{display:'flex',flexDirection:'column',gap:6}}>
                  {allBots.map(b => (
                    <div key={b.id} onClick={()=>setCopyTargetBot(String(b.id))} style={{
                      padding:'10px 14px',borderRadius:8,cursor:'pointer',
                      border:`1.5px solid ${copyTargetBot===String(b.id)?'#4ade80':'rgba(255,255,255,0.1)'}`,
                      background: copyTargetBot===String(b.id)?'rgba(74,222,128,0.1)':'transparent',
                      display:'flex',alignItems:'center',gap:10,
                    }}>
                      <div style={{width:32,height:32,borderRadius:8,background:'linear-gradient(135deg,#22c55e,#16a34a)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16}}>🤖</div>
                      <div>
                        <div style={{fontSize:14,fontWeight:600,color:'var(--text)'}}>{b.name}</div>
                        <div style={{fontSize:11,color:'var(--text3)'}}>ID: {b.id} · {b.user_count||0} kullanıcı</div>
                      </div>
                      {copyTargetBot===String(b.id) && <span style={{marginLeft:'auto',color:'#4ade80',fontSize:18}}>✓</span>}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {copyTargetBot && (
              <div style={{background:'rgba(74,222,128,0.08)',border:'1px solid rgba(74,222,128,0.2)',borderRadius:8,padding:10,marginBottom:16,fontSize:12,color:'#4ade80'}}>
                ℹ️ Flow kopyalandıktan sonra hedef botta <b>pasif</b> olarak oluşturulur. Etkinleştirmek için o botun Flow editöründen açabilirsiniz.
              </div>
            )}
            <div style={{display:'flex',gap:10}}>
              <button className="btn btn-ghost" onClick={()=>setShowCopyModal(false)} style={{flex:1,justifyContent:'center'}}>İptal</button>
              <button className="btn btn-primary" onClick={copyFlow} disabled={!copyTargetBot||copying} style={{flex:2,justifyContent:'center',background:copyTargetBot?'linear-gradient(135deg,#22c55e,#16a34a)':undefined}}>
                {copying ? 'Kopyalanıyor...' : '📋 Kopyala'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Geo Routing Modal */}
      {showGeoModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.75)',backdropFilter:'blur(4px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:3000}} onClick={e=>e.target===e.currentTarget&&setShowGeoModal(false)}>
          <div style={{background:'#111927',border:'1px solid rgba(255,255,255,0.12)',borderRadius:14,padding:28,width:500,maxHeight:'80vh',overflowY:'auto'}}>
            <div style={{fontSize:16,fontWeight:700,color:'#e2e8f0',marginBottom:6}}>🌍 Ülkeye Göre Yönlendirme</div>
            <div style={{fontSize:13,color:'#64748b',marginBottom:16}}>
              Kullanıcının Telegram dil ayarına göre farklı başlangıç node'una yönlendir.
            </div>

            <label style={{display:'flex',alignItems:'center',gap:10,cursor:'pointer',marginBottom:16}}>
              <label className="toggle">
                <input type="checkbox" checked={geoRouting.enabled||false} onChange={e=>setGeoRouting(g=>({...g,enabled:e.target.checked}))}/>
                <span className="toggle-slider"/>
              </label>
              <span style={{fontSize:14,color:'var(--text)',fontWeight:600}}>Geo Routing Aktif</span>
            </label>

            {geoRouting.enabled && (
              <>
                <div style={{fontSize:12,color:'#fbbf24',background:'rgba(251,191,36,0.08)',border:'1px solid rgba(251,191,36,0.2)',borderRadius:8,padding:10,marginBottom:16}}>
                  ⚠️ Node ID'sini canvas'ta node'a tıklayıp sol üstteki ID'den alabilirsin. Başlangıç node'unun ID'si genellikle <code>n_xxx</code> formatındadır.
                </div>

                <div style={{marginBottom:12}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
                    <label style={{fontSize:12,fontWeight:600,color:'var(--text2)'}}>KURALLAR</label>
                    <button className="btn btn-ghost btn-sm" onClick={()=>setGeoRouting(g=>({...g,rules:[...(g.rules||[]),{countries:['TR'],node_id:''}]}))}>
                      + Kural Ekle
                    </button>
                  </div>
                  {(geoRouting.rules||[]).map((rule, i) => (
                    <div key={i} style={{background:'rgba(255,255,255,0.04)',borderRadius:8,padding:12,marginBottom:8,border:'1px solid rgba(255,255,255,0.08)'}}>
                      <div style={{display:'flex',gap:8,marginBottom:8}}>
                        <div style={{flex:1}}>
                          <label style={{fontSize:10,color:'#6899cc',display:'block',marginBottom:4}}>ÜLKE KODLARI (virgülle, OTHER = diğer tümü)</label>
                          <input className="input" value={rule.countries.join(',')} onChange={e=>setGeoRouting(g=>{const r=[...g.rules];r[i]={...r[i],countries:e.target.value.toUpperCase().split(',').map(c=>c.trim()).filter(Boolean)};return {...g,rules:r};})}
                            placeholder="TR veya US,DE,FR veya OTHER" style={{fontSize:12}}/>
                        </div>
                        <button onClick={()=>setGeoRouting(g=>({...g,rules:g.rules.filter((_,idx)=>idx!==i)}))}
                          style={{background:'none',border:'none',color:'#f87171',cursor:'pointer',fontSize:18,alignSelf:'flex-end',padding:'4px 8px'}}>✕</button>
                      </div>
                      <div>
                        <label style={{fontSize:10,color:'#6899cc',display:'block',marginBottom:4}}>YÖNLENDİRİLECEK NODE ID</label>
                        <select className="input" value={rule.node_id} onChange={e=>setGeoRouting(g=>{const r=[...g.rules];r[i]={...r[i],node_id:e.target.value};return {...g,rules:r};})} style={{fontSize:12}}>
                          <option value="">— Node seç —</option>
                          {nodes.map(n => (
                            <option key={n.id} value={n.id}>
                              {ICONS[n.data?.type]||'📦'} {LABELS[n.data?.type]||n.data?.type} — {n.data?.content?.substring(0,30)||n.id}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div style={{fontSize:11,color:'var(--text3)',marginTop:6}}>
                        Ülkeler: {rule.countries.join(', ')||'—'} → {rule.node_id ? nodes.find(n=>n.id===rule.node_id)?.data?.content?.substring(0,30)||rule.node_id : '—'}
                      </div>
                    </div>
                  ))}
                  {(!geoRouting.rules||geoRouting.rules.length===0) && (
                    <div style={{textAlign:'center',color:'var(--text3)',fontSize:13,padding:20}}>Henüz kural yok. "+ Kural Ekle" butonuna bas.</div>
                  )}
                </div>

                <div style={{background:'rgba(59,130,246,0.06)',borderRadius:8,padding:10,fontSize:12,color:'#60a5fa',marginBottom:16,lineHeight:1.7}}>
                  <b>Ülke kodları:</b> TR (Türkiye), US (ABD), DE (Almanya), RU (Rusya), AZ (Azerbaycan), GB (İngiltere), FR (Fransa), AR (Arjantin/Arapça)<br/>
                  <b>OTHER</b> = Listede olmayan tüm ülkeler için varsayılan
                </div>
              </>
            )}

            <div style={{display:'flex',gap:10,marginTop:8}}>
              <button className="btn btn-ghost" onClick={()=>setShowGeoModal(false)} style={{flex:1,justifyContent:'center'}}>İptal</button>
              <button className="btn btn-primary" onClick={()=>{setShowGeoModal(false);}} style={{flex:2,justifyContent:'center'}}>
                ✓ Tamam (Kaydet ile aktif olur)
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function FlowEditor({ bot, onBack }) {
  return <ReactFlowProvider><FlowEditorInner bot={bot} onBack={onBack}/></ReactFlowProvider>;
}
